import React, { useState, useEffect, useMemo } from "react";
import {
  Form,
  InputGroup,
  Modal,
  Button,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import axios from "axios";
import BASE_URL from "../../../assets/global/url";
import { useForm, useFieldArray, useWatch, Controller } from "react-hook-form";
import { useNavigate, Link, useParams } from "react-router-dom";
import swal from "sweetalert";
import useDecodeToken from "../../../hooks/customHook/useDecodeToken";
import { addDays, format } from "date-fns";
import Select from "react-select";
import { selectCustomStyles } from "../../../assets/global/selectCustomStyles";
import useDarkMode from "../../../components/Themes/Usedarkmode";
import CustomDatePicker from "../../../components/CustomDatePicker";
import NumberInDecimals from "../../../components/inputs/NumberFormatted";
import TypedDateInput from "../../../components/inputs/TypedDateInput";
import {
  currencySymbol,
  formatCurrency,
  formatNumberWithComma,
  formatToTwoDecimal,
  parseNumber,
  truncateToTwoDecimals,
} from "../../../utils/numberFormatter";

// FOR EDITS
import { usePayablePDF, PayablePDFFrame } from "./PayablePDF2";
import { usePayableActions } from "./utils/updateConstants";
import CommissionList, {
  toCommissionPayload,
} from "./components/CommissionList";
import {
  warnIfNoCutoff,
  checkCutoffDate,
} from "../../../utils/cutoffDateValidation";

const NewCreateViewPayable = ({ authrztn }) => {
  const { themeSelectStyles } = useDarkMode();
  const { id: editPOID } = useParams();
  const userLoggedID = useDecodeToken();
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [warehouse, setWarehouse] = useState([]);

  const [product, setProduct] = useState([]);
  const [payableProduct, setPayableProduct] = useState([]);
  const [vendors, setVendors] = useState([]);
  // const [totalMoisture, setTotalMoisture] = useState(0);
  // const [totalWeight, setTotalWeight] = useState(0); // truncated — used for Subtotal / Gross Amount
  // const [rawTotalWeight, setRawTotalWeight] = useState(0); // untruncated — used for Total Qty Amount display
  const [otherFees, setOtherFees] = useState([]);
  const [totalFees, setTotalFees] = useState(0);
  const OTHER_FEE_PAGE_SIZE = 5;
  const [otherFeePage, setOtherFeePage] = useState(0);
  const [isPercent, setIsPercent] = useState(true);
  const [primary_discount, setPrimary_discount] = useState("");
  const [discountBackend, setDiscountBackend] = useState("");
  const [currency, setCurrency] = useState([]);
  const [vendorSelected, setVendorSelected] = useState(false);
  const [taxSettings, setTaxSettings] = useState([]);
  const [isSpecialTax, setIsSpecialTax] = useState(false);
  const [backupVat, setBackupVat] = useState("");
  const [backupTaxId, setBackupTaxId] = useState("");
  const [backupTaxRate, setBackupTaxRate] = useState(0);

  // FOR EDITS
  const {
    rejectPOTransaction,
    approvePOTransaction,
    fetchDataForView,
    handleSaveUpdateChanges,
  } = usePayableActions(BASE_URL, userLoggedID, formatNumberWithComma);
  const [viewPDFModal, setViewPDFModal] = useState(false);
  // Generated once each time the PDF modal opens, shared by viewer and download
  const payablePdf = usePayablePDF(editPOID, viewPDFModal);
  const [current_status, setCurrent_status] = useState(false);
  const [isApproving, setIsApproving] = useState(false);
  const [stateValidation, setStateValidation] = useState({
    isCutoffPosted: false,
    isCutoffExists: false,
    isAdded: false,
  });
  const [isEditable, setIsEditable] = useState(editPOID ? false : true);

  const openPDFPreview = () => {
    // window.open(`/pdf-view?id=${id}`, "_blank");
    setViewPDFModal(true);
  };

  const canEdit =
    editPOID &&
    current_status === "Pending" &&
    authrztn.includes("Payable-Edit");

  const canPostApprovalEdit =
    editPOID &&
    current_status === "Approved" &&
    authrztn.includes("Payable-PostApprovalEdit");

  const showPreviewButton = !isEditable;

  //  -----------------END

  const handleDiscountChange = (value) => {
    if (!value || value === ".") {
      setPrimary_discount(value);
      return;
    }

    const numValue = parseFloat(value) || 0;
    // const currentSubtotal =
    //   parseFloat(totalWeight || 0) - parseFloat(totalMoisture || 0);

    if (isPercent && numValue > 100) {
      swal({
        icon: "error",
        title: "Invalid Discount",
        text: "Percentage discount cannot exceed 100%.",
      }).then(() => {
        setPrimary_discount("100");
      });
      return;
    }

    if (!isPercent && numValue > TotalAmountBreakdownSubtotal) {
      swal({
        icon: "error",
        title: "Invalid Discount",
        text: `Discount cannot exceed the subtotal of ${formatCurrency(TotalAmountBreakdownSubtotal, currentCurrency)}.`,
      }).then(() => {
        setPrimary_discount(TotalAmountBreakdownSubtotal.toFixed(2));
      });
      return;
    }

    setPrimary_discount(value);
  };

  const handleDiscountToggle = () => {
    // const currentSubtotal =
    //   parseFloat(totalWeight || 0) - parseFloat(totalMoisture || 0);
    const currentDiscountNum = parseFloat(primary_discount) || 0;

    let newDiscount = "0";

    if (isPercent) {
      const flatValue =
        (currentDiscountNum / 100) * TotalAmountBreakdownSubtotal;
      newDiscount = flatValue.toFixed(2);
    } else {
      if (TotalAmountBreakdownSubtotal > 0) {
        const percentValue =
          (currentDiscountNum / TotalAmountBreakdownSubtotal) * 100;
        newDiscount = percentValue.toFixed(2);
      }
    }

    if (newDiscount === "0" || newDiscount === "0.00") {
      newDiscount = "";
    }

    setPrimary_discount(newDiscount);
    setIsPercent(!isPercent);
  };

  // Add this function to calculate the discount
  const calculateDiscount = () => {
    const formatDiscount = parseNumber(primary_discount) || 0;

    const numValue = parseFloat(formatDiscount);
    if (isNaN(numValue)) return setDiscountBackend(numValue);

    if (isPercent) {
      const discounted = (numValue / 100) * TotalAmountBreakdownSubtotal;
      setDiscountBackend(discounted);
      // return numValue / 100;
    } else {
      setDiscountBackend(numValue);
      // return numValue;
    }
  };

  // const onInputFloat = (e) => {
  //   e.target.value = e.target.value.replace(/[^0-9.]/g, "");
  // };

  const onInputFloat = (e) => {
    // If current value is "0" and user types a digit, replace it
    if (
      e.target.value.startsWith("0") &&
      e.target.value.length === 2 &&
      e.target.value[1] !== "."
    ) {
      e.target.value = e.target.value.slice(1);
    }
    e.target.value = e.target.value.replace(/[^0-9.]/g, "");
  };

  const addNewFee = () => {
    const newFees = [...otherFees, { feeName: "", feeAmount: "" }];
    setOtherFees(newFees);
    setOtherFeePage(Math.floor((newFees.length - 1) / OTHER_FEE_PAGE_SIZE));
  };

  const handleFeeChange = (index, field, value) => {
    const newOtherFees = otherFees.map((fee, i) =>
      i === index ? { ...fee, [field]: value } : fee,
    );
    setOtherFees(newOtherFees);
  };
  const removeFee = (index) => {
    const newOtherFees = otherFees.filter((_, i) => i !== index);
    setOtherFees(newOtherFees);
    const newTotalPages = Math.ceil(newOtherFees.length / OTHER_FEE_PAGE_SIZE);
    if (otherFeePage >= newTotalPages && otherFeePage > 0) {
      setOtherFeePage((p) => p - 1);
    }
  };

  const addNewItem = () => {
    append({
      product_vendor_id: "",
      productId: "",
      productCode: "",
      productName: "",
      moisture: 0,
      moistureType: "%",
      weight: "",
      net_weight: 0,
      unitPrice: 0,
      original_php_price: 0,
      totalPrice: 0,
      discount: "",
      discountType: "%",
    });
  };

  const scrollPageToBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth",
    });
  };

  const scrollPageToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const dateToday = () => {
    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const year = today.getFullYear();

    return `${year}-${month}-${day}`;
  };

  const twoWeeks = () => {
    const date = new Date(dateToday());
    date.setDate(date.getDate() + 14);

    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;
  };

  const defaultItems = {
    product_vendor_id: "",
    productId: "",
    productCode: "",
    productName: "",
    moistureType: "%",
    moisture: 0,
    weight: "",
    net_weight: 0,
    unitPrice: 0,
    supplier_price: 0,
    original_php_price: 0, // Stores the raw PHP base price for currency re-conversion
    totalPrice: 0,
    discount: "", // per-product discount value
    discountType: "%", // "%" or "fixed"
  };

  const {
    register,
    control,
    setValue,
    watch,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      transactionId: "",
      clientTransactionId: "",
      warehouseId: "",
      vendorId: "",
      modeOfPayment: "",
      customerType: "",
      trackingNumber: "",
      dueDate: twoWeeks(),
      // weightedQuantity: "",
      // netWeight: "",
      weighingFee: "",
      purchaseDate: dateToday(),
      description: "",
      currencyId: "",
      containerNumber: "",
      pier: "",
      currencyRate: "",
      vat: "",
      taxId: "",
      taxRate: 0,
      commissions: [],
      items: Array.from({ length: 5 }, () => ({ ...defaultItems })),
      // Old items default
      // items: [
      //   {
      //     product_vendor_id: "",
      //     productId: "",
      //     productCode: "",
      //     productName: "",
      //     moistureType: "%",
      //     moisture: 0,
      //     weight: "",
      //     net_weight: 0,
      //     unitPrice: 0,
      //     supplier_price: 0,
      //     totalPrice: 0,
      //   },
      // ],
    },
  });

  // useWatch values
  const [purchaseDate, currencyId, vat, taxId, taxRate, weighingFee] = useWatch(
    {
      control,
      name: [
        "purchaseDate",
        "currencyId",
        "vat",
        "taxId",
        "taxRate",
        "weighingFee",
      ],
    },
  );

  useEffect(() => {
    if (!purchaseDate) return;

    const deadline = addDays(purchaseDate, 14);

    setValue("dueDate", deadline, {
      shouldValidate: true,
      shouldDirty: true,
    });
  }, [purchaseDate, setValue]);

  // Find the currency name
  const findCurrencyName = currency.find(
    (item) => currencyId && item.id === currencyId,
  );
  const currentCurrency = findCurrencyName?.currency_name || "PHP";

  //Function for formatting the number using userForm
  // const formatNumber = (value) => {
  //   if (!value) return ""; // Handle empty input

  //   // Remove non-numeric characters except for the decimal point
  //   let inputValue = value.replace(/[^0-9.]/g, "");

  //   // Split into integer and decimal parts
  //   let [integerPart, decimalPart] = inputValue.split(".");

  //   // Format the integer part with commas
  //   integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  //   // Combine integer and decimal parts (if any)
  //   return decimalPart !== undefined
  //     ? `${integerPart}.${decimalPart}`
  //     : integerPart;
  // };

  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });
  const itemsValues = useWatch({
    control,
    name: "items",
    defaultValue: [],
  });

  //commented kasi may perfered calculation na for moisture to net weight yung sa ylluja

  // const calculateTotalMoisture = () => {
  //   const totalMoisture = itemsValues.reduce((acc, item) => {
  //     const moisture =
  //       parseFloat(item.moisture.toString()?.replace(/,/g, "")) || 0;
  //     const weight = parseFloat(item.weight.toString()?.replace(/,/g, "")) || 0;
  //     const unitPrice =
  //       parseFloat(item.unitPrice.toString()?.replace(/,/g, "")) || 0;

  //     if (item.moistureType === "%") {
  //       // Calculate percentage of (unitPrice * weight)
  //       return acc + (moisture / 100) * unitPrice * weight;
  //     } else {
  //       // Moisture is in peso, add directly
  //       return acc + moisture;
  //     }
  //   }, 0);

  //   setTotalMoisture(totalMoisture);
  // };

  // const calculateTotalMoisture = () => {
  //   const totalMoisture = itemsValues.reduce((acc, item) => {
  //     const moisture = parseNumber(item.moisture);
  //     const weight = parseNumber(item.weight);
  //     const unitPrice = parseNumber(item.unitPrice);

  //     if (item.moistureType === "%") {
  //       if (moisture === 0) return acc;
  //       // Moisture amount = weight × moisture% × unitPrice (exact, no truncation)
  //       const moistureAmount = weight * (moisture / 100) * unitPrice;

  //       return acc + moistureAmount;
  //     } else {
  //       // Moisture is in peso, add directly
  //       return acc + moisture;
  //     }
  //   }, 0);

  //   setTotalMoisture(totalMoisture);
  // };

  // const calculateNetWeight = (index) => {
  //   const weight = parseNumber(watch(`items.${index}.weight`));
  //   const moisture = parseNumber(watch(`items.${index}.moisture`));
  //   const unitPrice = parseNumber(watch(`items.${index}.unitPrice`));
  //   const moisture_type = watch(`items.${index}.moistureType`);

  //   let netWeight;

  //   // commented kasi may calculation for ylluja na dapat eradicate lahat ng decimal without rounding up

  //   // if (moisture_type === "%") {
  //   //   netWeight = weight * (1 - moisture / 100);
  //   // } else {
  //   //   netWeight = weight - moisture / unitPrice;
  //   // }

  //   if (moisture_type === "%") {
  //     netWeight = Math.trunc(weight * (1 - moisture / 100));
  //   } else {
  //     netWeight = Math.trunc(weight - moisture / unitPrice);
  //   }

  //   if (netWeight < 0) {
  //     swal({
  //       title: "Invalid Net Weight Amount.",
  //       text: "Net Weight Amount cannot be less than 0",
  //       button: true,
  //       icon: "error",
  //     }).then(() => {
  //       setValue(`items.${index}.moisture`, "");
  //       setValue(`items.${index}.net_weight`, 0);
  //       setValue(`items.${index}.totalPrice`, 0);
  //     });
  //     return;
  //   }
  //   setValue(`items.${index}.net_weight`, formatNumberWithCommas(netWeight));
  //   const totalPrice = netWeight * unitPrice;
  //   setValue(`items.${index}.totalPrice`, formatNumberWithCommas(totalPrice));
  // };

  // const calculateMoisture = (index, value) => {
  //   const weight = parseNumber(watch(`items.${index}.weight`));
  //   let moisture = parseNumber(watch(`items.${index}.moisture`));
  //   const unitPrice = parseNumber(watch(`items.${index}.unitPrice`));
  //   const moisture_type = watch(`items.${index}.moistureType`);

  //   let netWeight = value;

  //   if (moisture_type === "%") {
  //     moisture = 100 * (1 - netWeight / weight).toFixed(2);
  //   } else {
  //     netWeight = weight - moisture / unitPrice;
  //   }

  //   if (netWeight > weight) {
  //     swal({
  //       title: "Invalid Net Weight Amount.",
  //       text: "Net Weight Amount should not exceed weight amount",
  //       button: true,
  //       icon: "error",
  //     }).then(() => {
  //       setValue(`items.${index}.moisture`, "");
  //       setValue(`items.${index}.net_weight`, 0);
  //       setValue(`items.${index}.totalPrice`, 0);
  //     });
  //     return;
  //   }

  //   // Format and set netWeight
  //   setValue(`items.${index}.moisture`, formatNumberWithCommas(moisture));
  //   const totalPrice = netWeight * unitPrice;
  //   setValue(`items.${index}.totalPrice`, formatNumberWithCommas(totalPrice));
  // };

  // useEffect(() => {
  //   const calculateTotalWeight = () => {
  //     const totalWeight = itemsValues.reduce((acc, item) => {
  //       const weight = parseNumber(item.weight);
  //       const unitPrice = parseNumber(item.unitPrice);
  //       const moisture = parseNumber(item.moisture);

  //       // When no moisture is entered, calculateNetWeight applies Math.trunc to the
  //       // weight regardless of moistureType (both "%" and peso paths truncate when
  //       // moisture === 0).  Mirror that here so totalWeight, Total Net Qty Amount,
  //       // and productSubtotal all stay consistent with the per-row subtotal display.
  //       if (moisture === 0) {
  //         return acc + Math.trunc(weight) * unitPrice;
  //       }

  //       return acc + weight * unitPrice;
  //     }, 0);
  //     setTotalWeight(totalWeight);

  //     // Raw (untruncated) total weight amount — preserves decimals like 1441.5 × 1 = 1441.50
  //     // Used for "Total Qty Amount" and "Total Net Qty Amount" display rows only.
  //     const rawTotalWeightValue = itemsValues.reduce((acc, item) => {
  //       const weight = parseNumber(item.weight);
  //       const unitPrice = parseNumber(item.unitPrice);
  //       return acc + weight * unitPrice;
  //     }, 0);
  //     setRawTotalWeight(rawTotalWeightValue);
  //   };

  //   const calculateTotalFees = () => {
  //     const total = otherFees.reduce((acc, fee) => {
  //       const feeAmount = parseFloat(fee.feeAmount) || 0;
  //       return acc + feeAmount;
  //     }, 0);
  //     setTotalFees(total.toFixed(2));
  //   };

  //   calculateDiscount();

  //   calculateTotalMoisture();
  //   calculateTotalWeight();
  //   calculateTotalFees();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [itemsValues, otherFees, isPercent, primary_discount, discountBackend]);

  const fetchWarehousData = () => {
    axios
      .get(BASE_URL + "/warehouse/getWarehouse")
      .then((res) => {
        setWarehouse(res.data);

        //Auto select warehouse if none is set
        if (res.data.length > 0 && !watch("warehouseId")) {
          setValue("warehouseId", res.data[0].warehouse_id);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const fetchLastCode = () => {
    axios
      .get(BASE_URL + "/payable/getCode")
      .then((res) => {
        setValue("transactionId", res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    // Display-only PO-YY-MM-0001 preview for a new PO. The server assigns
    // the real code on save; an existing PO shows its saved code instead.
    if (editPOID) return;
    axios
      .get(BASE_URL + "/payable/getClientCodePreview")
      .then((res) => {
        const { prefix, nextSeq } = res.data;
        setValue(
          "clientTransactionId",
          `${prefix}${String(nextSeq).padStart(4, "0")}`,
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchActivePurchaseTaxes = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/payable/getActivePurchaseTax`);
      setTaxSettings(res.data);
    } catch (error) {
      console.error(error);
    }
  };
  const resetTableProduct = () => {
    // Reset all product selections in the items array
    const itemsCount = watch("items").length;
    for (let i = 0; i < itemsCount; i++) {
      setValue(`items.${i}.product_vendor_id`, "");
      setValue(`items.${i}.productId`, "");
      setValue(`items.${i}.productCode`, "");
      setValue(`items.${i}.productName`, "");
      setValue(`items.${i}.unitPrice`, 0);
      setValue(`items.${i}.original_php_price`, 0);
      setValue(`items.${i}.totalPrice`, 0);

      setValue(`items.${i}.weight`, "");
      setValue(`items.${i}.moisture`, 0);
      setValue(`items.${i}.net_weight`, 0);
      setValue(`items.${i}.discount`, "");
      setValue(`items.${i}.discountType`, "%");
    }
  };
  const fetchProductData = (selectedOption) => {
    // const vendorId = selectedOption;
    // ginawang ganito para sa update kasi ID lang ng supplier ang meron sa pag fetch
    const vendorId =
      typeof selectedOption === "object"
        ? selectedOption?.value
        : selectedOption;
    axios
      .get(BASE_URL + "/payable/getProductData", {
        params: {
          vendorId: vendorId,
        },
      })
      .then((res) => {
        setProduct(res.data);

        // console.log(`Product`, res.data);
        // if (!editPOID) {

        // }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchPayableProduct = (selectedOption) => {
    // const vendorId = selectedOption;
    // ginawang ganito para sa update kasi ID lang ng supplier ang meron sa pag fetch
    const vendorId =
      typeof selectedOption === "object"
        ? selectedOption?.value
        : selectedOption;
    axios
      .get(BASE_URL + "/payable/getPayableProduct", {
        params: {
          vendorId: vendorId,
        },
      })
      .then((res) => {
        setPayableProduct(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchVenderData = () => {
    axios
      .get(BASE_URL + "/vendors/fetchVendors")
      .then((res) => {
        setVendors(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchCurrency = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/currency/fetchCurrency`);
      setCurrency(res.data);

      // --- COMMENTED OUT: PREVENT AUTO-DEFAULT TO PHP ---
      // const phpCurrency = res.data.find(
      //   (item) => item.id === "11111111-1111-1111-1111-111111111111",
      // );
      //
      // setValue("currencyId", phpCurrency?.id);
      // setValue("currencyRate", phpCurrency?.currency_rate);
      // --------------------------------------------------
    } catch (error) {
      console.log(error);
    }
  };

  const [cutOff, setCutOff] = useState([]);

  const fetchLatestCutOff = () => {
    axios
      .get(BASE_URL + "/cutoff/getCurrentCutOff")
      .then((res) => {
        setCutOff(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const dateValidation = async (selectedDate, value, dateLabel) => {
    try {
      const res = await axios.get(`${BASE_URL}/cutoff/dateValidation`, {
        params: {
          date: selectedDate,
        },
      });
      // TEMP DEBUG — remove once we confirm the actual response shape
      console.log("[dateValidation] fired for", selectedDate, "→", res.data);
      setStateValidation((prev) => ({
        ...prev,
        isCutoffPosted: res.data.isCutoffPosted,
        isCutoffExists: !!res.data.cutoffExists,
      }));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchWarehousData();
    fetchVenderData();
    fetchLastCode();
    fetchLatestCutOff();
    fetchCurrency();
    fetchActivePurchaseTaxes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const total = otherFees.reduce(
      (sum, fee) => sum + (parseFloat(fee.feeAmount) || 0),
      0,
    );
    setTotalFees(total);
  }, [otherFees]);
  // ------------ COMMENTED TO USE THE REACT HOOK FORM "handleSubmit" ------------
  // //backend
  // const add = async (e) => {
  //   e.preventDefault();
  //   const form = e.currentTarget;

  //   const formatPrimaryDiscount = primary_discount.replace(/,/g, "");
  //   const currentCurrencyRate = watch("currencyRate");
  //   // const weighingFee =
  //   //   parseFloat(watch("weighingFee")?.replace(/,/g, "")) || 0;

  //   if (form.checkValidity() === false) {
  //     e.preventDefault();
  //     e.stopPropagation();
  //     swal({
  //       icon: "error",
  //       title: "Fields are required",
  //       text: "Please fill in the red text fields.",
  //     });
  //   } else {
  //     if (totalAmount === 0) {
  //       const wrapper = document.createElement("div");
  //       wrapper.className = "center-swal-text";
  //       wrapper.innerHTML =
  //         "The Total Amount must be greater than zero. Please check your input.";
  //       swal({
  //         icon: "error",
  //         title: "Invalid Amount",
  //         content: wrapper,
  //       });
  //       return;
  //     }

  //     dateValidation(watch("purchaseDate"), "purchaseDate", "Purchase Date");

  //     swal({
  //       title: "Create this new purchase?",
  //       text: "",
  //       icon: "warning",
  //       buttons: true,
  //       dangerMode: true,
  //     }).then((confirmed) => {
  //       if (confirmed) {
  //         const formData = new FormData(form);
  //         formData.append("otherFee", JSON.stringify(otherFees));
  //         formData.append("primary_discount", formatPrimaryDiscount);
  //         formData.append("isPercent", isPercent);
  //         formData.append("createdBy", userLoggedID);
  //         formData.append("currencyRate", currentCurrencyRate || 1);
  //         formData.append(
  //           "dueDate",
  //           watch("dueDate") ? format(watch("dueDate"), "yyyy-MM-dd") : "",
  //         );
  //         formData.append(
  //           "purchaseDate",
  //           watch("purchaseDate")
  //             ? format(watch("purchaseDate"), "yyyy-MM-dd")
  //             : "",
  //         );
  //         const data = Object.fromEntries(formData.entries());

  //         data.items = [];
  //         form.querySelectorAll('[name^="items"]').forEach((input) => {
  //           const matches = input.name.match(/^items\.(\d+)\.(.+)$/);
  //           if (matches) {
  //             const index = matches[1];
  //             const key = matches[2];
  //             if (!data.items[index]) data.items[index] = {};
  //             const modifiedValue = input.value?.replace(/,/g, "");
  //             data.items[index][key] = modifiedValue;

  //             // Calculate totalAmount and set it for each item
  //             const weight = parseFloat(
  //               data.items[index].weight?.replace(/,/g, "") || 0,
  //             );
  //             const moisture = parseFloat(
  //               data.items[index].moisture?.replace(/,/g, "") || 0,
  //             );
  //             const weighingFee =
  //               parseFloat(watch("weighingFee")?.replace(/,/g, "")) || 0;
  //             const discount = parseFloat(discountBackend) || 0;

  //             data.items[index].totalAmount =
  //               weight - moisture - weighingFee - discount;
  //           }
  //         });

  //         data.calculatedAmount = calculatedAmount; // Add to data object

  //         // Send data via Axios
  //         axios
  //           .post(`${BASE_URL}/payable/create`, data, {
  //             headers: {
  //               "Content-Type": "application/json",
  //             },
  //           })
  //           .then((res) => {
  //             if (res.status === 200) {
  //               swal({
  //                 title: "Success",
  //                 text: "Purchase created successfully",
  //                 icon: "success",
  //                 buttons: false,
  //                 timer: 2000,
  //                 dangerMode: true,
  //               }).then(() => {
  //                 navigate("../purchases/payable");
  //               });
  //             }
  //             // else if (res.status === 201) {
  //             //   swal({
  //             //     title: "Opppss!",
  //             //     text: "Cutoff already posted for this date",
  //             //     icon: "warning",
  //             //     buttons: false,
  //             //     timer: 2000,
  //             //     dangerMode: true,
  //             //   });
  //             // }
  //             else {
  //               swal({
  //                 title: "Something Went Wrong",
  //                 text: "Please contact your support immediately",
  //                 icon: "error",
  //                 buttons: false,
  //                 timer: 2000,
  //                 dangerMode: true,
  //               });
  //             }
  //           })
  //           .catch((error) => {
  //             if (error.response && error.response.status === 409) {
  //               swal({
  //                 icon: "error",
  //                 title: "Transaction ID Conflict",
  //                 text: "The transaction ID you entered already exists in the system. Please use a unique identifier.",
  //               });
  //             }
  //           });
  //       }
  //     });
  //   }
  //   setValidated(true);
  // };
  // ------------ COMMENTED TO USE THE REACT HOOK FORM "handleSubmit" ------------

  // ------------ NEW FORM SUBMISSION SAME LOGIC SA OLD BUT USING RHF ------------
  // New onSubmit Form. Uses the react hook form "handleSubmit" instead of manual form submission
  // Same logic sa old form submission
  const onSubmit = async (data) => {
    const validItems = data.items.filter(
      (item) => item.product_vendor_id !== "",
    );

    if (validItems.length === 0) {
      swal({
        icon: "error",
        title: "No Products Selected",
        text: "Please select at least one product to create a purchase.",
      });
      return;
    }

    // Validation for empty moisture on valid items
    const itemsWithEmptyMoisture = validItems
      .map((item) => ({ item, rowNumber: data.items.indexOf(item) + 1 }))
      .filter(
        ({ item }) =>
          item.moisture === "" ||
          item.moisture === null ||
          item.moisture === undefined,
      );

    if (itemsWithEmptyMoisture.length > 0) {
      const rowLabels = itemsWithEmptyMoisture
        .map(
          ({ item, rowNumber }) =>
            `Row ${rowNumber} - ${item.productName || "Unknown Product"}`,
        )
        .join("\n");
      swal({
        icon: "error",
        title: "Missing Moisture",
        text: `Please fill in the Moisture field for the following item(s) before saving.\nEnter 0 if there is no moisture deduction.\n\n${rowLabels}`,
      });
      return;
    }

    if (FinalPayableAmount <= 0) {
      const wrapper = document.createElement("div");
      wrapper.className = "center-swal-text";
      wrapper.innerHTML = "The Total Amount must be greater than zero.";
      swal({ icon: "error", title: "Invalid Amount", content: wrapper });
      return;
    }

    // Date Validation Function is commented since its function is commented
    // await dateValidation(data.purchaseDate, "purchaseDate", "Purchase Date");

    const confirmed = await swal({
      title: "Create this new purchase?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirmed) {
      try {
        const payload = {
          ...data,
          otherFee: JSON.stringify(otherFees),
          primary_discount: parseNumber(primary_discount) || 0,
          isPercent: isPercent,
          createdBy: userLoggedID,
          currencyRate: watch("currencyRate") || 1,
          calculatedAmount: FinalPayableAmount.toFixed(2),
          vat: parseFloat(watch("vat") || 0),
          purchaseDate: format(new Date(data.purchaseDate), "yyyy-MM-dd"),
          dueDate: format(new Date(data.dueDate), "yyyy-MM-dd"),
          tax_id: data.taxId || null,
          tax_rate: parseFloat(data.taxRate || 0),
          isSpecialTax: isSpecialTax,
          commissions: toCommissionPayload(data.commissions),
          items: validItems.map((item) => {
            const weight = parseNumber(item.weight);
            const moisture = parseNumber(item.moisture);

            const rawWFee = parseNumber(weighingFee);
            const wFee =
              rawWFee === null || rawWFee === undefined || isNaN(rawWFee)
                ? 0
                : rawWFee;
            const disc = parseNumber(discountBackend);

            return {
              ...item,
              weight: String(item.weight).replace(/,/g, ""),
              moisture: String(item.moisture).replace(/,/g, ""),
              unitPrice: parseNumber(item.unitPrice),
              // unitPrice: item.original_php_price
              //   ? String(
              //       parseFloat(item.original_php_price) /
              //         (parseFloat(watch("currencyRate")) || 1),
              //     )
              //   : String(item.unitPrice).replace(/,/g, ""),
              net_weight: String(item.net_weight).replace(/,/g, ""),
              discount: parseNumber(item.discount) || 0,
              discountType: item.discountType || "%",
              totalAmount: weight - moisture - wFee - disc,
            };
          }),
        };

        const res = await axios.post(`${BASE_URL}/payable/create`, payload);

        if (res.status === 200) {
          swal({
            title: "Success",
            text: "Purchase created successfully",
            icon: "success",
            timer: 2000,
            buttons: false,
          }).then(() => navigate("../purchases/payable"));
        }
      } catch (error) {
        if (error.response?.status === 409) {
          swal({
            icon: "error",
            title: "Transaction ID Conflict",
            text: "The transaction ID already exists.",
          });
        } else {
          console.error(error);
          swal({
            icon: "error",
            title: "Error",
            text: "Something went wrong.",
          });
        }
      }
    }
    setValidated(true);
  };

  // Error handling for handleSubmit
  const onInvalid = (errors) => {
    console.log("Form Errors:", errors);
    swal({
      icon: "error",
      title: "Missing Fields",
      text: "Please fill in all required fields highlighted in red.",
    });
  };
  // ------------ NEW FORM SUBMISSION SAME LOGIC SA OLD BUT USING RHF ------------

  // const [calculatedAmount, setCalculatedAmount] = useState(0);

  // // -------------------- New Calculation --------------------
  // // ─── Product subtotal (before fees) ───────────────────────────────────────
  // const productSubtotal =
  //   parseFloat(totalWeight || 0) - parseFloat(totalMoisture || 0);

  // // ─── Gross Amount = product subtotal minus discount ────────────────────────
  // const grossAmount = productSubtotal - (parseFloat(discountBackend) || 0);

  // // ─── VAT — basis is grossAmount (products only) ────────────────────────────
  // const vRate = parseFloat(vat || 0) / 100;
  // // const vatAmount = grossAmount * vRate;
  // const vatAmount = isSpecialTax ? 0 : grossAmount * vRate;

  // // ─── Withholding Tax — basis is grossAmount (products only) ───────────────
  // const tRate = parseFloat(taxRate || 0) / 100;
  // // const taxAmount = grossAmount * tRate;
  // const taxAmount = isSpecialTax ? 0 : grossAmount * tRate;

  // // ─── Special Tax Computation ───────────────────────────────────────────────
  // const specialTaxAmount = isSpecialTax ? grossAmount * 0.1088 : 0;

  // // ─── Non-taxable fees added last ───────────────────────────────────────────
  // const weighingFeeAmount = parseNumber(weighingFee) || 0;

  // // ─── Total Amount ──────────────────────────────────────────────────────────
  // const totalAmount =
  //   grossAmount +
  //   vatAmount -
  //   taxAmount +
  //   specialTaxAmount -
  //   weighingFeeAmount -
  //   (parseFloat(totalFees) || 0);

  // ------------------------------------------------------------------------------

  const calculateTotalWeightInKilo = itemsValues.reduce((total, value) => {
    return (
      total + (parseFloat(value.weight.toString()?.replace(/,/g, "")) || 0)
    );
  }, 0);

  // const calculateTotalMoistureInKilo = itemsValues.reduce((total, value) => {
  //   const parseValue = (val) => {
  //     const parsed = parseFloat(val?.toString().replace(/,/g, "") || 0);
  //     return isNaN(parsed) ? 0 : parsed;
  //   };

  //   const moisture = parseValue(value.moisture);
  //   const unitPrice = parseValue(value.unitPrice);
  //   const weight = parseValue(value.weight);

  //   if (value.moistureType === "%") {
  //     if (moisture === 0) return total;
  //     // Moisture in kg = weight × moisture% (exact, no truncation)
  //     const moistureInKg = weight * (moisture / 100);

  //     return total + moistureInKg;
  //   } else {
  //     const moistureInKg = unitPrice > 0 ? moisture / unitPrice : 0;
  //     return total + moistureInKg;
  //   }
  // }, 0);

  const calculateTotalNetWeightInKilo = itemsValues.reduce((total, value) => {
    const moisture = parseNumber(value.moisture);
    const weight = parseNumber(value.weight);

    // When moisture is 0, net_weight was stored as Math.trunc(weight).
    // Use the raw weight instead so Total Net Qty shows the full decimal (e.g. 1441.50).
    if (moisture === 0) {
      return total + weight;
    }

    return total + parseFloat(value.net_weight.toString()?.replace(/,/g, ""));
  }, 0);

  const formatNumberWithCommas = (number) => {
    return new Intl.NumberFormat("en-US").format(number);
  };

  // Unit Price shown when a product is picked or the currency changes:
  // 2 decimals unless the 3rd or 4th decimal has a value, then all 4.
  // Keeps the thousands commas.
  // 80 -> 80.00, 80.5 -> 80.50, 1.001 -> 1.0010, 80.0001 -> 80.0001,
  // 1234.5 -> 1,234.50, 0 -> 0.0000
  const formatUnitPriceDisplay = (value) => {
    const fixed = Number(value).toFixed(4);
    if (!Number.isFinite(Number(fixed)) || Number(fixed) === 0) return "0.0000";

    return formatNumberWithComma(
      fixed.endsWith("00") ? fixed.slice(0, -2) : fixed,
    );
  };

  // Vendor Options for dropdown select
  const vendorOptions = vendors.map((item) => ({
    value: item.id,
    label: item.company_name || `${item.fname} ${item.lname}`,
  }));

  // Product Option for dropdown select
  const productOptions = product.map((item) => ({
    value: item.id, // product vendor id
    label: item.product_list.product_name,
  }));

  // Lets the Product Name select wrap long names onto multiple lines
  // (control grows taller) and widens the open dropdown so wrapped
  // option text reads naturally. Layered on top of selectCustomStyles
  // so the shared style file and the other Select instances that use
  // it (e.g. the vendor select) are untouched.
  const withWrappableProductStyles = (baseStyles) => ({
    ...baseStyles,
    control: (provided, state) => ({
      ...(baseStyles.control ? baseStyles.control(provided, state) : provided),
      height: "auto",
      minHeight: "38px",
      alignItems: "flex-start",
    }),
    valueContainer: (provided, state) => ({
      ...(baseStyles.valueContainer
        ? baseStyles.valueContainer(provided, state)
        : provided),
      flexWrap: "wrap",
      overflow: "visible",
      paddingTop: "6px",
      paddingBottom: "6px",
    }),
    singleValue: (provided, state) => ({
      ...(baseStyles.singleValue
        ? baseStyles.singleValue(provided, state)
        : provided),
      position: "relative",
      whiteSpace: "normal",
      overflow: "visible",
      textOverflow: "unset",
      wordBreak: "break-word",
      maxWidth: "100%",
    }),
    menu: (provided, state) => ({
      ...(baseStyles.menu ? baseStyles.menu(provided, state) : provided),
      width: "max-content",
      minWidth: "100%",
      maxWidth: "440px",
    }),
    option: (provided, state) => ({
      ...(baseStyles.option ? baseStyles.option(provided, state) : provided),
      whiteSpace: "normal",
      wordBreak: "break-word",
    }),
  });

  // const filteredProductOptions = (index) => {
  //   const productIdList = itemsValues
  //     .filter((_, i) => i !== index)
  //     .map((item) => item.product_vendor_id);

  //   const filteredProduct = product.filter(
  //     (item) => !productIdList.includes(item.id),
  //   );

  //   return filteredProduct.map((item) => ({
  //     value: item.id,
  //     label: item.product_list.product_name,
  //   }));
  // };

  // Fetch Vendor then set the currency and currency rate based on selected vendor
  const fetchVendorCurrencyId = async (selectedOption) => {
    try {
      const res = await axios.get(`${BASE_URL}/vendors/fetchVendorsedit`, {
        params: {
          id: selectedOption?.value,
        },
      });
      // Set currency
      const [vendor] = res.data;
      setValue("currencyId", vendor.currency_id);

      // Set currency rate
      const vendorCurrency = currency.find(
        (item) => item.id === vendor.currency_id,
      );
      setValue("currencyRate", vendorCurrency.currency_rate);
      setValue("vat", vendor.vat_percent);

      // --- ADDED: AUTO SELECT TYPE BASED ON COMPANY DESIGNATION ---
      if (vendor.company_designation) {
        const designation = vendor.company_designation.toLowerCase();
        if (designation.includes("local")) {
          setValue("customerType", "local");
        } else if (
          designation.includes("international") ||
          designation.includes("overseas")
        ) {
          setValue("customerType", "overseas");
        }
      }
      // -----------------------------------------------------------
    } catch (error) {
      console.error(error);
    }
  };

  // Custom input for DatePicker: typed as MM/dd/yyyy and shown as Oct/10/2026
  // (TypedDateInput). Only a complete date reaches handleDateChange, so the
  // cutoff check doesn't run on a half-typed date.
  const CustomInput = useMemo(() => {
    const Input = React.forwardRef(
      (
        {
          value,
          onClick,
          onChange,
          onBlur,
          onFocus,
          onKeyDown,
          disabled,
          generateYears,
        },
        ref,
      ) => {
        return (
          <TypedDateInput
            className="form-control p-2 w-100"
            onClick={(e) => {
              if (onClick) onClick(e);

              let dateYear = new Date().getFullYear();
              if (value) {
                const parsed = new Date(value);
                if (!isNaN(parsed.getTime())) {
                  dateYear = parsed.getFullYear();
                }
              }

              if (generateYears && typeof generateYears === "function") {
                generateYears(dateYear); // Reset/Initialize Year List based on selected date
              }
            }}
            onChange={onChange}
            onBlur={onBlur}
            onFocus={onFocus}
            onKeyDown={onKeyDown}
            value={value}
            ref={ref}
            disabled={disabled}
            required
          />
        );
      },
    );

    Input.displayName = "CustomInput";
    return Input;
  }, []);

  const currencyList = {
    PHP: "Philippine Peso (Philippines)",
    USD: "US Dollar (United States)",
    CNY: "Chinese Yuan (China)",
    HKD: "Hong Kong Dollar (Hong Kong)",
    EUR: "Euro (European Union)",
    JPY: "Japanese Yen (Japan)",
  };

  // For Item list input select width
  const selectProductWidth = Math.max(
    ...itemsValues.map((item) => item.productName.length),
  );

  /* ---------- Function Dates ----------  */
  // Purchase Date
  const selectedPurchaseDate = watch("purchaseDate")
    ? new Date(watch("purchaseDate"))
    : "";
  const handlePurchaseDateChange = async (date) => {
    // warnIfNoCutoff(date, "Purchase Date"); // Replaced by checkCutoffDate (also checks posted cutoffs)
    const previousDate = watch("purchaseDate");
    setValue("purchaseDate", date, { shouldValidate: true });

    // A date inside an already posted (previous) cutoff can't be used:
    // warn and put the previous Purchase Date back.
    const cutoffStatus = await checkCutoffDate(date, "Purchase Date");
    if (cutoffStatus === "posted") {
      setValue("purchaseDate", previousDate, { shouldValidate: true });
    }
  };
  const maxPurchaseDate = new Date();

  // Deadline or Due Date
  const selectedDueDate = watch("dueDate") ? new Date(watch("dueDate")) : "";
  const handleDueDateChange = (date) => {
    warnIfNoCutoff(date, "Deadline");
    return setValue("dueDate", date, { shouldValidate: true });
  };
  const minDueDate = purchaseDate ? new Date(purchaseDate) : "";
  if (minDueDate) {
    minDueDate.setDate(minDueDate.getDate() + 1);
  }
  /* ---------- Function Dates ----------  */

  const handleSpecialTax = (e) => {
    const isChecked = e.target.checked;
    setIsSpecialTax(isChecked);

    if (isChecked) {
      setBackupVat(watch("vat"));
      setBackupTaxId(watch("taxId"));
      setBackupTaxRate(watch("taxRate"));

      setValue("vat", "");
      setValue("taxId", "");
      setValue("taxRate", 0);
    } else {
      setValue("vat", backupVat);
      setValue("taxId", backupTaxId);
      setValue("taxRate", backupTaxRate);
    }
  };

  // ------------------------------------- Revised handlers ------------------------------
  const handleQtyChange = (weight_value, index) => {
    const unitPrice = parseNumber(watch(`items.${index}.unitPrice`)) || 0;

    const formatWeight = parseNumber(weight_value);

    setValue(
      `items.${index}.totalPrice`,
      truncateToTwoDecimals(formatWeight * unitPrice),
    );
    setValue(`items.${index}.weight`, weight_value);
    setValue(`items.${index}.net_weight`, weight_value);

    //para d mag conflict at marami e adjust  kaya e reset
    setValue(`items.${index}.moisture`, 0);
    setValue(`items.${index}.moistureType`, "%");

    // calculateTotalMoisture();
    // calculateNetWeight(index);

    // autoCalculateNetWeightTableKG();
  };

  const handleMoistureChange = (value, index) => {
    // const moisture_type = watch(`items.${index}.moisture_type`) || 0;
    // Auto-clear default "0" when user starts typing
    if (value.length === 2 && value[0] === "0" && value[1] !== ".") {
      value = value[1];
    }

    if (parseNumber(value) > 100) {
      swal({
        icon: "error",
        title: "Moisture should not exceed 100",
        text: "Percentage moisture cannot exceed 100%.",
      });

      setValue(`items.${index}.moisture`, "100");
      return;
    }

    const moisture_decimal = value / 100;

    autoCalculateNetWeightWithSubTotalTableKG(moisture_decimal, index);

    setValue(`items.${index}.moisture`, value);
  };

  const handleNetWeightChange = (raw_value, index) => {
    const sanitizedNetValue = parseNumber(raw_value);

    const weightTBL = watch(`items.${index}.weight`) || 0;
    const sanitizedWeight = parseNumber(weightTBL);

    // Auto-clear default "0" when user starts typing
    if (
      raw_value.length === 2 &&
      raw_value[0] === "0" &&
      raw_value[1] !== "."
    ) {
      raw_value = raw_value[1];
    }

    // must not exceed qty
    if (parseNumber(sanitizedNetValue) > sanitizedWeight) {
      swal({
        icon: "error",
        title: "Net Weight limitation",
        text: "Net weight cannot exceed QTY.",
      });

      setValue(`items.${index}.net_weight`, weightTBL);
      return;
    }

    // ------------------- get moisture percent

    const moisturePercent =
      ((sanitizedWeight - sanitizedNetValue) / sanitizedWeight) * 100;
    setValue(`items.${index}.moisture`, formatToTwoDecimal(moisturePercent));

    // ------------------ get Subtotal
    const unitPrice = parseNumber(watch(`items.${index}.unitPrice`)) || 0;
    const formatSubtotal = truncateToTwoDecimals(sanitizedNetValue * unitPrice);
    setValue(`items.${index}.totalPrice`, formatSubtotal);

    // final set value to netweight

    setValue(`items.${index}.net_weight`, raw_value);
  };

  const handleUnitPriceChange = (raw_value, index) => {
    const sanitizedUnitPrice = parseNumber(raw_value);
    const sanitizedNetWeight = parseNumber(
      watch(`items.${index}.net_weight`) || 0,
    );
    if (
      raw_value.length === 2 &&
      raw_value[0] === "0" &&
      raw_value[1] !== "."
    ) {
      raw_value = raw_value[1]; // Keep only the new digit
    }

    // ----------------  calculate Subtotal
    const formatSubtotal = truncateToTwoDecimals(
      sanitizedNetWeight * sanitizedUnitPrice,
    );
    setValue(`items.${index}.totalPrice`, formatSubtotal);

    // --------------- final set value to unitPrice
    setValue(`items.${index}.unitPrice`, raw_value);
  };

  // ---------------- Calculation for breakdown amounts
  const calculateTotalWeightAmount = itemsValues.reduce((total, value) => {
    return (
      total + (parseNumber(value.weight) * parseNumber(value.unitPrice) || 0)
    );
  }, 0);

  const calculateTotalNetWeightAmount = itemsValues.reduce((total, value) => {
    return (
      total +
      (parseNumber(value.net_weight) * parseNumber(value.unitPrice) || 0)
    );
  }, 0);

  // const calculateTotalMoistureAmount = itemsValues.reduce((total, value) => {
  //   return total + calculateTotalWeightAmount - calculateTotalNetWeightAmount;
  // }, 0);

  // ─── Per-product discount ──────────────────────────────────────────────────
  // Base is the row's net qty amount (net_weight × unitPrice), capped so a row
  // can never go below zero even if qty/price is lowered after the discount.
  const getItemBaseAmount = (item) =>
    (parseNumber(item?.net_weight) || 0) * (parseNumber(item?.unitPrice) || 0);

  const getItemDiscountAmount = (item) => {
    const base = getItemBaseAmount(item);
    const value = parseNumber(item?.discount) || 0;
    const amount = item?.discountType === "fixed" ? value : (value / 100) * base;
    return Math.min(Math.max(amount, 0), base);
  };

  const handleItemDiscountChange = (value, index) => {
    const item = watch(`items.${index}`);
    const numValue = parseNumber(value) || 0;
    const base = getItemBaseAmount(item);

    if (item.discountType !== "fixed" && numValue > 100) {
      swal({
        icon: "error",
        title: "Invalid Discount",
        text: "Percentage discount cannot exceed 100%.",
      });
      setValue(`items.${index}.discount`, "100");
      return;
    }

    if (item.discountType === "fixed" && numValue > base) {
      swal({
        icon: "error",
        title: "Invalid Discount",
        text: `Discount cannot exceed the item subtotal of ${formatCurrency(base, currentCurrency)}.`,
      });
      setValue(`items.${index}.discount`, base.toFixed(2));
      return;
    }

    setValue(`items.${index}.discount`, value);
  };

  const handleItemDiscountToggle = (index) => {
    const item = watch(`items.${index}`);
    const current = parseNumber(item.discount) || 0;
    const base = getItemBaseAmount(item);
    const toFixedType = item.discountType !== "fixed";

    let converted = 0;
    if (toFixedType) {
      converted = (current / 100) * base;
    } else if (base > 0) {
      converted = (current / base) * 100;
    }

    setValue(
      `items.${index}.discount`,
      converted > 0 ? converted.toFixed(2) : "",
    );
    setValue(`items.${index}.discountType`, toFixedType ? "fixed" : "%");
  };

  const calculateTotalItemDiscount = itemsValues.reduce(
    (total, item) => total + getItemDiscountAmount(item),
    0,
  );

  // pwede naman na calculateTotalNetWeightAmount na agad sa subtotal nilagay ko lang sa constant para sa ibang calculation d na malito ang iba
  // Subtotal is now net qty amount less the per-product discounts
  const TotalAmountBreakdownSubtotal =
    calculateTotalNetWeightAmount - calculateTotalItemDiscount;

  const totalGrossAmountBreakdown =
    TotalAmountBreakdownSubtotal - (parseFloat(discountBackend) || 0);

  // ─── VAT — basis is grossAmount (products only) ────────────────────────────
  const vatPercentToDecimal = parseFloat(vat || 0) / 100;
  const vatAmountBreakdown = isSpecialTax
    ? 0
    : totalGrossAmountBreakdown * vatPercentToDecimal;

  // ─── Withholding Tax — basis is grossAmount (products only) ───────────────
  const WHTaxPercentTODecimal = parseFloat(taxRate || 0) / 100;

  const WHTaxBreakdownAmount = isSpecialTax
    ? 0
    : totalGrossAmountBreakdown * WHTaxPercentTODecimal;

  // ─── Special Tax Computation ───────────────────────────────────────────────
  const specialTaxAmountBreakdown = isSpecialTax
    ? totalGrossAmountBreakdown * 0.1088
    : 0;

  // ─── Non-taxable fees added last ───────────────────────────────────────────
  const weighingFeeAmountBreakdown = parseNumber(weighingFee) || 0;

  // ─── Total Amount ──────────────────────────────────────────────────────────
  const FinalPayableAmount =
    totalGrossAmountBreakdown +
    vatAmountBreakdown -
    WHTaxBreakdownAmount +
    specialTaxAmountBreakdown -
    weighingFeeAmountBreakdown -
    (parseFloat(totalFees) || 0);

  // useEffects
  useEffect(() => {
    calculateDiscount();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [primary_discount, discountBackend]);

  // Loads/reloads the PO data from the server and resets the form to it.
  // Reused on initial mount and again when the user cancels an edit, so
  // canceling discards unsaved changes by pulling the real saved data back
  // in, instead of just leaving the edited values sitting in the form.
  const loadPOData = () => {
    if (!editPOID) return;
    fetchDataForView(
      editPOID,
      setCurrent_status,
      setStateValidation,
      reset,
      setIsSpecialTax,
      setIsPercent,
      setPrimary_discount,
      setVendorSelected,
      fetchProductData,
      fetchPayableProduct,
      setOtherFees,
    );
  };

  // EDITS USEFFECt
  useEffect(() => {
    loadPOData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCancelEdit = () => {
    loadPOData();
    setIsEditable(false);
  };

  // --------------------- helpers
  const autoCalculateNetWeightWithSubTotalTableKG = (
    moisture_decimal,
    index,
  ) => {
    const weightTBL = watch(`items.${index}.weight`) || 0;

    const sanitizedWeight = parseNumber(weightTBL);

    const raw_calculate = Math.trunc(sanitizedWeight * (1 - moisture_decimal));

    let formatNetWeight = 0;

    if (moisture_decimal !== 0) {
      formatNetWeight = truncateToTwoDecimals(raw_calculate);
    } else {
      formatNetWeight = sanitizedWeight;
    }

    setValue(`items.${index}.net_weight`, formatNetWeight);

    // ----------------------    calculate subtotal
    const unitPrice = parseNumber(watch(`items.${index}.unitPrice`)) || 0;
    const formatSubtotal = truncateToTwoDecimals(raw_calculate * unitPrice);
    setValue(`items.${index}.totalPrice`, formatSubtotal);
  };

  const handleInitalApproveConstant = async (e) => {
    const id = editPOID;
    const status = "Approved";
    const dataProduct = watch("items");
    const vendorId = watch("vendorId");
    const purchaseDate = watch("purchaseDate");
    const transaction_id = watch("transactionId");
    const warehouseID = watch("warehouseId");
    const currencyRate = watch("currencyRate") || 1;
    const currencyName = findCurrencyName?.currency_name ?? "PHP";

    setIsApproving(true);
    try {
      const isApproved = await approvePOTransaction(
        e,
        id,
        status,
        dataProduct,
        vendorId,
        purchaseDate,
        transaction_id,
        warehouseID,
        currencyRate,
        currencyName,
        FinalPayableAmount,
      );

      if (isApproved) {
        setCurrent_status("Approved");
        setViewPDFModal(false);
      }
    } finally {
      setIsApproving(false);
    }
  };

  const handleEditableAfterSave = (value) => {
    setIsEditable(value);
    if (!value) {
      loadPOData();
    }
  };

  const handleSaveUpdateInitial = () => {
    const domestic_type = watch("customerType");
    const tracking_number =
      domestic_type === "local" ? null : watch("trackingNumber");
    const purchaseDate = watch("purchaseDate");
    const vendorId = watch("vendorId");
    const warehouseId = watch("warehouseId");
    const due_date = watch("dueDate");
    const containerNumber = watch("containerNumber");
    const pier = watch("pier");
    const currencyId = watch("currencyId");
    const description = watch("description");

    const id = editPOID;
    const dataProduct = watch("items");
    const currencyRate = watch("currencyRate");
    const weighingFee = parseNumber(watch("weighingFee")) || 0;
    const totalAmount = FinalPayableAmount || 0;
    const vat = watch("vat");
    const tax_id = watch("taxId");
    const tax_rate = watch("taxRate");
    const discount = parseNumber(primary_discount) || 0;
    const discountType = isPercent ? "%" : currencySymbol[currentCurrency];
    const clientTransactionId = watch("clientTransactionId");
    const commissionsString = JSON.stringify(
      toCommissionPayload(watch("commissions")),
    );

    // FIX: Stringify the array here so it maintains exact order through the network payload
    const otherFeesString = JSON.stringify(otherFees);

    if (
      domestic_type !== "local" &&
      (tracking_number === "" || tracking_number === null)
    ) {
      swal({
        title: "Required Field Missing",
        text: "Please ensure Tracking Number is filled out.",
        icon: "error",
        buttons: false,
        timer: 3000,
      });
      return;
    }

    if (!purchaseDate) {
      swal({
        title: "Required Field Missing",
        text: "Please ensure Purchase Date is filled out.",
        icon: "error",
        buttons: false,
        timer: 3000,
      });
      return;
    }

    // Validation: every item with a product selected must have a Qty greater than 0.
    // (dataProduct = watch("items")) — catches a newly added row left at the default
    // blank/0 Qty, which previously slipped through since this Save handler doesn't
    // run through the form's handleSubmit/required validation.
    const itemsWithNoQty = dataProduct
      .map((item, idx) => ({ item, rowNumber: idx + 1 }))
      .filter(({ item }) => {
        if (!item.product_vendor_id) return false;
        return !(parseNumber(item.weight) > 0);
      });

    if (itemsWithNoQty.length > 0) {
      const rowLabels = itemsWithNoQty
        .map(
          ({ item, rowNumber }) =>
            `Row ${rowNumber} - ${item.productName || "Unknown Product"}`,
        )
        .join("\n");
      swal({
        icon: "error",
        title: "Missing Quantity",
        text: `Please enter a Qty greater than 0 for the following item(s) before saving.\n\n${rowLabels}`,
      });
      return;
    }

    if (FinalPayableAmount === 0) {
      const wrapper = document.createElement("div");
      wrapper.className = "center-swal-text";
      wrapper.innerHTML =
        "The Total Amount must be greater than zero. Please check your input.";
      swal({
        icon: "error",
        title: "Invalid Amount",
        content: wrapper,
      });
      return;
    }

    handleSaveUpdateChanges(
      tracking_number,
      domestic_type,
      purchaseDate,
      vendorId,
      warehouseId,
      due_date,
      containerNumber,
      pier,
      currencyId,
      description,
      id,
      dataProduct,
      currencyRate,
      weighingFee,
      totalAmount,
      vat,
      tax_id,
      tax_rate,
      isSpecialTax,
      discount,
      discountType,
      otherFeesString, // <-- Pass the stringified array instead of the raw array
      clientTransactionId,
      handleEditableAfterSave,
      commissionsString,
    );
  };

  const handleInitialRejectConstant = async (e) => {
    const isRejected = await rejectPOTransaction(e, editPOID);

    if (isRejected) {
      setCurrent_status("Rejected");
      setViewPDFModal(false);
    }
  };

  return (
    <div className="h-100 w-100 border bg-white custom-container">
      <style>{`
        .scroll-fab {
          width: 46px;
          height: 46px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.18);
          transition: transform 0.18s ease, box-shadow 0.18s ease;
        }
        .scroll-fab:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
        }
        .scroll-fab:active {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }
      `}</style>
      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit(onSubmit, onInvalid)}
        id="form-create-payable"
      >
        <div className="w-100 p-2 d-flex flex-row justify-content-between">
          <div className="d-flex flex-column title-custom">
            <span className="fs-3">
              {" "}
              <Link to="/purchases/payable" className="text-dark mx-2">
                <i class="fa-solid fa-arrow-left"></i>
              </Link>
              PURCHASE DETAILS
            </span>
            <span>Current Cutoff: {cutOff.name}</span>
          </div>
        </div>
        <div className="row mx-auto p-2 mt-2">
          <div className="d-none col-sm mb-2">
            <label htmlFor="transactionId">Transaction ID</label>
            <input
              type="text"
              id="transactionId"
              {...register("transactionId")}
              className="form-control p-2"
              readOnly
            />
          </div>
          <div className="col-sm mb-2">
            <label htmlFor="clientTransactionId">Transaction ID</label>
            {/* Display only - generated by the server (PO-YY-MM-0001) */}
            <input
              type="text"
              id="clientTransactionId"
              {...register("clientTransactionId")}
              className="form-control p-2"
              placeholder="Generating..."
              readOnly
            />
            {!editPOID && (
              <small className="text-muted">
                Final number is assigned on save.
              </small>
            )}
          </div>
          <div className="col-sm mb-2">
            <label htmlFor="warehouseId">
              Receiving Warehouse <span className="text-danger">*</span>
            </label>
            <select
              required
              id="warehouseId"
              {...register("warehouseId")}
              className="form-select p-2"
              disabled={!isEditable}
            >
              <option value="" disabled>
                Select Warehouse
              </option>
              {warehouse.map((data) => (
                <option key={data.warehouse_id} value={data.warehouse_id}>
                  {data.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="row mx-auto p-2">
          <div className="col-sm mb-2">
            <label htmlFor="vendorId">
              Supplier <span className="text-danger">*</span>
            </label>
            <Controller
              name="vendorId"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <Select
                  {...field}
                  isDisabled={!isEditable}
                  options={vendorOptions}
                  value={
                    vendorOptions.find((opt) => opt.value === field.value) ||
                    null
                  }
                  onChange={async (selectedOption) => {
                    field.onChange(selectedOption?.value);
                    fetchProductData(selectedOption);
                    fetchPayableProduct(selectedOption);
                    await fetchVendorCurrencyId(selectedOption);
                    setVendorSelected(!!selectedOption);
                    resetTableProduct();
                  }}
                  onMenuOpen={() => {
                    if (vendors.length === 0) {
                      const wrapper = document.createElement("div");
                      wrapper.classList.add("center-swal-text");
                      wrapper.innerHTML =
                        "No suppliers found. Please create one first.";
                      swal({
                        icon: "warning",
                        title: "No Supplier Found",
                        content: wrapper,
                      });
                    }
                  }}
                  menuIsOpen={vendors.length === 0 ? false : undefined}
                  placeholder="Select Supplier"
                  styles={themeSelectStyles(
                    selectCustomStyles(watch("vendorId"), validated, "0.12rem"),
                  )}
                  isSearchable
                />
              )}
            />
            {errors.vendorId && (
              <span className="text-danger small">
                Required to select supplier
              </span>
            )}
          </div>

          <div className="col-sm mb-2">
            <label htmlFor="modeOfPayment">Mode of Payment</label>
            <select
              id="modeOfPayment"
              {...register("modeOfPayment", {
                required: "Payment Mode is required",
              })}
              className="form-select p-2"
              required
              disabled={!isEditable}
            >
              <option value="" disabled>
                Select Payment
              </option>
              <option value="Cheque">Check</option>
              <option value="Cash">Cash</option>
              <option value="Online">Online</option>
            </select>
            {errors.modeOfPayment && (
              <span className="text-danger small">
                Required to select mode of payment
              </span>
            )}
          </div>
        </div>

        {vendorSelected && (
          <>
            <div className="row mx-auto p-2">
              <div className="col-sm mb-2">
                <label htmlFor="vat">
                  VAT (%)<span className="text-danger"> *</span>
                </label>
                <input
                  type="text"
                  id="vat"
                  className="form-control p-2"
                  placeholder="0.00"
                  required
                  maxLength={6}
                  disabled={isSpecialTax || !isEditable}
                  {...register("vat", {
                    onChange: (e) => {
                      let value = e.target.value.replace(/[^0-9.]/g, "");
                      const parts = value.split(".");
                      if (parts.length > 2)
                        value = parts[0] + "." + parts.slice(1).join("");
                      if (parts[1]?.length > 2)
                        value = parts[0] + "." + parts[1].slice(0, 2);
                      if (parseFloat(value) > 100) value = "100";
                      setValue("vat", value);
                    },
                  })}
                />
              </div>

              <div className="col-sm mb-2">
                <label htmlFor="taxId">Tax</label>
                <select
                  id="taxId"
                  className="form-select p-2"
                  disabled={isSpecialTax || !isEditable}
                  {...register("taxId", {
                    onChange: (e) => {
                      const selected = taxSettings.find(
                        (t) => String(t.id) === String(e.target.value),
                      );
                      setValue("taxRate", selected ? selected.rate : 0);
                    },
                  })}
                >
                  <option value="">None</option>
                  {taxSettings.map((tax) => (
                    <option key={tax.id} value={tax.id}>
                      {tax.name} - {tax.rate}%
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </>
        )}

        <div className="row mx-auto p-2">
          <div className="col-sm mb-2">
            <div className="d-flex justify-content-center gap-2">
              <div
                // className={`${
                //   watch("currencyId") == "11111111-1111-1111-1111-111111111111"
                //     ? "w-100"
                //     : "w-50 me-3"
                // } `}
                className="w-100"
              >
                <div className="mb-4">
                  <label htmlFor="currencyId">
                    Currency <span className="text-danger">*</span>
                    {watch("currencyId") &&
                    watch("currencyId") !==
                      "11111111-1111-1111-1111-111111111111" ? (
                      <span className="text-muted mb-1">
                        {" "}
                        Current Rate: {watch("currencyRate") || 1}
                      </span>
                    ) : null}
                  </label>
                  <select
                    id="currencyId"
                    // {...register("currencyId")}
                    className="form-select p-2"
                    required
                    disabled={!isEditable}
                    // Commented to fix currency not passing to the database
                    // {...register("currencyId")}
                    {...register("currencyId", {
                      onChange: (e) => {
                        const selectedValue = e.target.value;
                        const curr = currency.find(
                          (data) => String(data.id) === String(selectedValue),
                        );
                        if (!curr) return;
                        const newRate = parseFloat(curr.currency_rate) || 1;
                        setValue("currencyRate", newRate);

                        // Recalculate all item unit prices when currency changes
                        const currentItems = watch("items");
                        currentItems.forEach((item, idx) => {
                          const phpPrice =
                            parseFloat(item.original_php_price) || 0;
                          if (item.product_vendor_id && phpPrice > 0) {
                            const convertedPrice = parseFloat(
                              (phpPrice / newRate).toFixed(4),
                            );
                            const formatted =
                              formatUnitPriceDisplay(convertedPrice);

                            setValue(`items.${idx}.unitPrice`, formatted);
                            setValue(`items.${idx}.supplier_price`, formatted);

                            // Recalculate totals if weight is already set
                            const weight = parseNumber(item.weight);
                            if (weight > 0) {
                              const moisture = parseNumber(item.moisture);
                              const moistureType = item.moistureType;
                              let netWeight;
                              if (moistureType === "%") {
                                netWeight = Math.trunc(
                                  weight * (1 - moisture / 100),
                                );
                              } else {
                                netWeight = Math.trunc(
                                  weight - moisture / convertedPrice,
                                );
                              }
                              setValue(
                                `items.${idx}.net_weight`,
                                formatNumberWithCommas(netWeight),
                              );
                              setValue(
                                `items.${idx}.totalPrice`,
                                formatNumberWithCommas(
                                  netWeight * convertedPrice,
                                ),
                              );
                            }
                          }
                        });
                      },
                    })}
                  >
                    <option value="" disabled>
                      Select Currency
                    </option>
                    {currency.map((data) => (
                      <option key={data.id} value={data.id}>
                        {data.currency_name} -{" "}
                        {currencyList[data.currency_name]}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {watch("currencyId") !== "" &&
              watch("currencyId") ===
                "11111111-1111-1111-1111-111111111111" ? null : (
                <>
                  {/* <div className="w-50"> */}
                  <div>
                    <div className="mb-4 d-none">
                      <label htmlFor="currencyId">
                        Currency Rate <span className="text-danger">*</span>
                      </label>
                      <Form.Control
                        type="text"
                        name=""
                        onInput={onInputFloat}
                        id=""
                        className="form-control p-2"
                        readOnly
                        {...register("currencyRate")}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="row mt-4">
              <div className="col-sm mb-3 d-flex flex-row justify-content-between">
                <div className="w-50 me-3">
                  <span>Container Number</span>
                  <Form.Control
                    type="text"
                    name=""
                    id=""
                    className="form-control p-2"
                    maxLength={50}
                    readOnly={!isEditable}
                    {...register("containerNumber")}
                  />
                </div>
                <div className="w-50">
                  <span>Pier</span>
                  <Form.Control
                    type="text"
                    name=""
                    id=""
                    className="form-control p-2"
                    maxLength={50}
                    readOnly={!isEditable}
                    {...register("pier")}
                  />
                </div>
              </div>
            </div>

            <div className="mb-4">
              <CommissionList
                control={control}
                register={register}
                currencyName={currentCurrency}
                readOnly={!isEditable}
              />
            </div>

            {/*Old Customer Type */}
            {/* <label htmlFor="">Type</label>
            <div className="d-flex align-items-center justify-content-center mt-2 pt-2">
              <input
                type="radio"
                id="localPurchase"
                value="local"
                {...register("customerType")}
                className="me-2"
                disabled
              />
              <label htmlFor="localPurchase" className="me-4">
                Local Purchase
              </label>
              <input
                type="radio"
                id="overseasPurchase"
                value="overseas"
                {...register("customerType")}
                className="me-2"
                disabled
              />
              <label htmlFor="overseasPurchase">Overseas Purchase</label>
            </div> */}

            {/* REDESIGN CUSTOMER TYPE SELECTION */}
            <div>
              <label htmlFor="customerType">
                Designation <span className="text-danger">*</span>
              </label>
              <select
                id="customerType"
                {...register("customerType")}
                className="form-select p-2"
                required
                disabled={!isEditable}
              >
                <option value="" disabled>
                  Select Designation
                </option>
                <option value="local">Local Purchase</option>
                <option value="overseas">Overseas Purchase</option>
              </select>
            </div>

            {watch("customerType") === "overseas" && (
              <div className="mt-4">
                <label htmlFor="trackingNumber">Tracking Number</label>
                <input
                  required
                  type="text"
                  id="trackingNumber"
                  {...register("trackingNumber")}
                  placeholder="Enter Tracking Number"
                  className="form-control p-2"
                  readOnly={!isEditable}
                />
              </div>
            )}
          </div>
          {/* Purchase Date */}
          <div className="col-sm mb-2">
            <label htmlFor="purchaseDate">
              Purchase Date <span className="text-danger">*</span>
            </label>
            <CustomDatePicker
              label={"Purchase Date"}
              field={"purchaseDate"}
              selected={selectedPurchaseDate}
              handleDateChange={handlePurchaseDateChange}
              setter={setValue}
              CustomInput={CustomInput}
              isRequired={true}
              validated={validated}
              dateValidation={dateValidation}
              maxDate={maxPurchaseDate}
              disabled={!isEditable}

              // OLD purchase date config
              // selected={
              //   watch("purchaseDate") ? new Date(watch("purchaseDate")) : ""
              // }
              // handleDateChange={(date) => {
              //   setValue("purchaseDate", date, { shouldValidate: true });
              //   dateValidation(date, "purchaseDate", "Purchase Date");
              // }}
            />
            {/* Deadline */}
            <div className="mt-5">
              <label htmlFor="dueDate">
                Deadline <span className="text-danger">*</span>
              </label>
              <CustomDatePicker
                label={"Deadline"}
                field={"dueDate"}
                selected={selectedDueDate}
                handleDateChange={handleDueDateChange}
                setter={setValue}
                CustomInput={CustomInput}
                validated={validated}
                minDate={minDueDate}
                disabled={!isEditable}
                // OLD Deadline date config
                // selected={watch("dueDate") ? new Date(watch("dueDate")) : ""}
                // handleDateChange={(date) => {
                //   if (
                //     validateDueDateGreaterThanPurchaseDate(date, purchaseDate)
                //   ) {
                //     setValue("dueDate", date, { shouldValidate: true });
                //   }
                // }}
              />
            </div>

            <div className="mt-4">
              <label htmlFor="description">Remarks</label>
              <textarea
                id="description"
                {...register("description")}
                maxLength={250}
                className="form-control p-2"
                rows={3}
                disabled={!isEditable}
              ></textarea>
            </div>
          </div>
        </div>

        {/* HIDE OLD WEIGHING DETAILS */}
        {/* <div className="w-100 mt-4 d-flex align-items-center">
          <span>Weighing Details</span>
          <hr className="flex-grow-1 mx-3" />
        </div>

        <div className="row mx-auto p-2">
          <div className="col-sm">
            <label htmlFor="weighingFee">
              Weighing Fee <span className="text-danger">*</span>
            </label>
            <div className="input-group mb-2">
              <div className="input-group-prepend">
                <div className="input-group-text p-3 text-secondary">
                  {currencySymbol[findCurrencyName?.currency_name ?? "PHP"]}
                </div>
              </div>
              <input
                type="text"
                onInput={onInputFloat}
                required
                {...register("weighingFee", {
                  onChange: (e) => {
                    const formattedValue = formatNumber(e.target.value);
                    setValue("weighingFee", formattedValue);
                  },
                })}
                className="form-control p-2"
                placeholder="0"
              />
            </div>
          </div>
          <div className="col-sm"></div>
        </div> */}

        <div className="w-100 mt-4">
          {/* OLD item list design */}
          {/* <label htmlFor="" className="mb-2">
            Item List
          </label> */}
          <div className="w-100 my-3 d-flex align-items-center">
            <span className="fs-5">Item Lists</span>
            <hr className="flex-grow-1 mx-3" />
          </div>
          <button
            type="button"
            className="btn btn-primary rounded-circle scroll-fab"
            onClick={scrollPageToBottom}
            title="Scroll to Bottom"
            aria-label="Scroll to Bottom"
            style={{
              position: "fixed",
              right: "24px",
              bottom: "24px",
              zIndex: 1030,
            }}
          >
            <i className="fa-solid fa-arrow-down fs-5"></i>
          </button>
          <div
            className="w-100 new-item-custom scrollable-contents"
            style={{ overflowX: "auto" }}
          >
            <table className="table table-bordered table-hover item-list-table">
              <thead
                className="table-light"
                style={{ position: "sticky", top: 0, zIndex: 10 }}
              >
                <tr>
                  <th
                    className="p-2 invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                    }}
                  >
                    Product Code
                  </th>
                  <th
                    className="p-2 invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                    }}
                  >
                    Product Name <span className="text-danger">*</span>
                  </th>
                  <th
                    className="p-2 invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                    }}
                  >
                    Qty <span className="text-danger">*</span>
                  </th>
                  <th
                    className="p-2 invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                    }}
                  >
                    Moisture <span className="text-danger">*</span>
                  </th>
                  <th
                    className="p-2 invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                    }}
                  >
                    Net Qty
                  </th>
                  <th
                    className="p-2 invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                    }}
                  >
                    Unit Price
                  </th>
                  <th
                    className="p-2 invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                    }}
                  >
                    Discount
                  </th>
                  <th
                    className="p-2 invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                    }}
                  >
                    Subtotal
                  </th>
                  <th
                    className="p-2 invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 10,
                    }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {fields.map((item, index) => (
                  <tr key={item.id}>
                    <td>
                      <input
                        type="hidden"
                        {...register(`items.${index}.productId`)}
                        className="form-control form-control-sm p-2"
                        readOnly
                      />
                      <input
                        {...register(`items.${index}.productCode`)}
                        className="form-control form-control-sm p-2"
                        readOnly
                      />
                    </td>
                    <td>
                      {/* Original Product Selection */}
                      {/* <select
                        required
                        {...register(`items.${index}.product_vendor_id`)}
                        className="form-select form-select-sm p-2"
                        onChange={(e) => {
                          const selectedValue = String(e.target.value, 10);
                          const selectedProduct = product.find(
                            (p) => String(p.id) === selectedValue
                          );

                          const selectedPayableProduct =
                            payableProduct.findLast(
                              (p) => p.product_vendor_id === selectedValue
                            );

                          console.log(selectedPayableProduct);

                          if (selectedPayableProduct) {
                            setValue(
                              `items.${index}.unitPrice`,
                              formatNumberWithCommas(
                                selectedPayableProduct.unitPrice
                              )
                            );
                            console.log("payableProduct");
                          } else {
                            setValue(
                              `items.${index}.unitPrice`,
                              formatNumberWithCommas(
                                selectedProduct.product_price
                              )
                            );
                            console.log("product");
                          }

                          if (selectedProduct) {
                            setValue(
                              `items.${index}.productId`,
                              selectedProduct.product_list.product_id
                            );
                            setValue(
                              `items.${index}.productName`,
                              selectedProduct.product_list.product_name
                            );
                            setValue(
                              `items.${index}.productCode`,
                              selectedProduct.product_list.product_code
                            );
                            // setValue(
                            //   `items.${index}.unitPrice`,
                            //   selectedProduct.product_price
                            // );
                            // Trigger calculation for totalPrice
                            const weight = watch(`items.${index}.weight`);
                            setValue(
                              `items.${index}.totalPrice`,
                              weight * selectedProduct.product_price
                            );
                            const totalPrice = watch(
                              `items.${index}.totalPrice`
                            );
                            calculateTotalMoisture();
                          }
                        }}
                        onMouseDown={(e) => {
                          if (product.length === 0) {
                            e.preventDefault();
                            const wrapper = document.createElement("div");
                            wrapper.classList.add("center-swal-text");
                            wrapper.innerHTML =
                              "No products found. Please create a product first to proceed.";
                            swal({
                              icon: "warning",
                              title: "No Product Found",
                              content: wrapper,
                            });
                            return;
                          }
                        }}
                        disabled={!watch("vendorId")}
                      >
                        <option value="" disabled>
                          Select Product
                        </option>
                        {product.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.product_list.product_name}
                          </option>
                        ))}
                      </select> */}

                      {/* Second Product Selection (Revision) */}
                      {/* <Controller
                        name={`items.${index}.product_vendor_id`}
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={productOptions}
                            value={
                              productOptions.find(
                                (opt) => opt.value === field.value,
                              ) || null
                            }
                            classNamePrefix="item-list-table-select"
                            onChange={async (selectedOption) => {
                              field.onChange(selectedOption?.value); // update form state
                              const selectedValue = String(
                                selectedOption?.value,
                                10,
                              );
                              const selectedProduct = product.find(
                                (p) => String(p.id) === selectedValue,
                              );

                              const selectedPayableProduct =
                                payableProduct.findLast(
                                  (p) => p.product_vendor_id === selectedValue,
                                );

                              // console.log(selectedPayableProduct);

                              if (selectedPayableProduct) {
                                setValue(
                                  `items.${index}.unitPrice`,
                                  formatNumberWithCommas(
                                    selectedPayableProduct.unitPrice,
                                  ),
                                );
                                setValue(
                                  `items.${index}.supplier_price`,
                                  formatNumberWithCommas(
                                    selectedPayableProduct.unitPrice,
                                  ),
                                );
                                // console.log("payableProduct");
                              } else {
                                setValue(
                                  `items.${index}.unitPrice`,
                                  formatNumberWithCommas(
                                    selectedProduct.product_price,
                                  ),
                                );
                                setValue(
                                  `items.${index}.supplier_price`,
                                  formatNumberWithCommas(
                                    selectedProduct.product_price,
                                  ),
                                );
                                // console.log("product");
                              }

                              if (selectedProduct) {
                                setValue(
                                  `items.${index}.productId`,
                                  selectedProduct.product_list.product_id,
                                );
                                setValue(
                                  `items.${index}.productName`,
                                  selectedProduct.product_list.product_name,
                                );
                                setValue(
                                  `items.${index}.productCode`,
                                  selectedProduct.product_list.product_code,
                                );
                                // setValue(
                                //   `items.${index}.unitPrice`,
                                //   selectedProduct.product_price
                                // );
                                // Trigger calculation for totalPrice
                                const weight = watch(`items.${index}.weight`);
                                setValue(
                                  `items.${index}.totalPrice`,
                                  weight * selectedProduct.product_price,
                                );
                                // const totalPrice = watch(
                                //   `items.${index}.totalPrice`
                                // );
                                calculateTotalMoisture();
                              }
                            }}
                            onMenuOpen={() => {
                              if (product.length === 0) {
                                const wrapper = document.createElement("div");
                                wrapper.classList.add("center-swal-text");
                                wrapper.innerHTML =
                                  "No products found. Please create a product first to proceed.";
                                swal({
                                  icon: "warning",
                                  title: "No Product Found",
                                  content: wrapper,
                                });
                                return;
                              }
                            }}
                            menuIsOpen={
                              product.length === 0 ? false : undefined
                            }
                            menuPortalTarget={document.body}
                            placeholder="Select Product"
                            styles={selectCustomStyles(
                              watch(`items.${index}.product_vendor_id`),
                              validated,
                              "0",
                              selectProductWidth,
                            )}
                            isDisabled={!watch("vendorId")}
                            isSearchable
                            // required
                          />
                        )}
                      /> */}

                      {/* -------------------- REVISED START -------------------- */}
                      {/* Third Product Selection (Revision) */}
                      {/* Re-used the "Second Product Selection" then will be revised */}
                      {/*  (ok in simple testing but need heavy testing especially multiple pendings) */}
                      <Controller
                        name={`items.${index}.product_vendor_id`}
                        control={control}
                        rules={{
                          required: index === 0 ? "Product is required" : false,
                        }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={productOptions}
                            value={
                              productOptions.find(
                                (opt) => opt.value === field.value,
                              ) || null
                            }
                            classNamePrefix="item-list-table-select"
                            onChange={async (selectedOption) => {
                              field.onChange(selectedOption?.value);

                              const selectedValue = String(
                                selectedOption?.value,
                                10,
                              );

                              // Find the base product details
                              const selectedProduct = product.find(
                                (p) => String(p.id) === selectedValue,
                              );

                              // Find the LATEST approved transaction for this product
                              // Filter all historical records for this specific product
                              const productHistory = payableProduct.filter(
                                (p) => p.product_vendor_id === selectedValue,
                              );

                              // Sort descending: Newest Approved Date first
                              // Fallback to purchaseDate or createdAt if date_approved is missing
                              productHistory.sort((a, b) => {
                                const dateA = new Date(
                                  a.payable.date_approved ||
                                    a.payable.purchaseDate ||
                                    a.createdAt,
                                );
                                const dateB = new Date(
                                  b.payable.date_approved ||
                                    b.payable.purchaseDate ||
                                    b.createdAt,
                                );
                                return dateB - dateA;
                              });

                              // The first item is now the latest
                              const selectedPayableProduct = productHistory[0];

                              // ── Currency Conversion ────────────────────────
                              // All product prices in the DB are stored in PHP.
                              // Divide by the current currency rate to convert.
                              // e.g. PHP 100 ÷ rate 60 = USD 1.67
                              const rawPhpPrice = selectedPayableProduct
                                ? selectedPayableProduct.unitPrice
                                : selectedProduct
                                  ? selectedProduct.product_price
                                  : 0;

                              const currentCurrencyRate =
                                parseFloat(watch("currencyRate")) || 1;
                              const convertedPrice = parseFloat(
                                (rawPhpPrice / currentCurrencyRate).toFixed(4),
                              );
                              const formattedConvertedPrice =
                                formatUnitPriceDisplay(convertedPrice);

                              // Persist the PHP base price so it can be
                              // re-converted if the user changes currency later
                              setValue(
                                `items.${index}.original_php_price`,
                                rawPhpPrice,
                              );

                              // Set converted unit price and supplier reference
                              setValue(
                                `items.${index}.unitPrice`,
                                formattedConvertedPrice,
                              );
                              setValue(
                                `items.${index}.supplier_price`,
                                formattedConvertedPrice,
                              );
                              // ───────────────────────────────────────────────

                              // Fill other product details
                              if (selectedProduct) {
                                setValue(
                                  `items.${index}.productId`,
                                  selectedProduct.product_list.product_id,
                                );
                                setValue(
                                  `items.${index}.productName`,
                                  selectedProduct.product_list.product_name,
                                );
                                setValue(
                                  `items.${index}.productCode`,
                                  selectedProduct.product_list.product_code,
                                );

                                // Trigger calculation for totalPrice using the converted price
                                const weight = watch(`items.${index}.weight`);
                                setValue(
                                  `items.${index}.totalPrice`,
                                  weight * convertedPrice,
                                );

                                // calculateTotalMoisture();
                              }
                              console.log("field.value", field.value);
                              console.log("productOptions", productOptions);
                            }}
                            onMenuOpen={() => {
                              if (product.length === 0) {
                                const wrapper = document.createElement("div");
                                wrapper.classList.add("center-swal-text");
                                wrapper.innerHTML =
                                  "No products found. Please create a product first to proceed.";
                                swal({
                                  icon: "warning",
                                  title: "No Product Found",
                                  content: wrapper,
                                });
                                return;
                              }
                            }}
                            menuIsOpen={
                              product.length === 0 ? false : undefined
                            }
                            menuPortalTarget={document.body}
                            placeholder="Select Product"
                            styles={themeSelectStyles(
                              withWrappableProductStyles(
                                selectCustomStyles(
                                  watch(`items.${index}.product_vendor_id`),
                                  !!errors.items?.[index]?.product_vendor_id,
                                  "0",
                                  selectProductWidth,
                                ),
                              ),
                            )}
                            isDisabled={!watch("vendorId") || !isEditable}
                            isSearchable
                            // required
                          />
                        )}
                      />
                      {errors.items?.[index]?.product_vendor_id && (
                        <span className="text-danger small">Required</span>
                      )}
                      {/* -------------------- REVISED START -------------------- */}
                    </td>
                    {/* Weight */}
                    <td>
                      <input
                        required
                        type="text"
                        onInput={onInputFloat}
                        // {...register(`items.${index}.weight`, {
                        //   onChange: (e) => {
                        //     const weight = formatNumber(e.target.value);
                        //     const unitPrice =
                        //       watch(`items.${index}.unitPrice`) || 0;

                        //     const formatWeight = parseFloat(
                        //       String(weight).replace(/,/g, ""),
                        //     );

                        //     setValue(
                        //       `items.${index}.totalPrice`,
                        //       formatWeight * unitPrice,
                        //     );

                        //     setValue(`items.${index}.weight`, weight);
                        //     calculateTotalMoisture();
                        //     calculateNetWeight(index);
                        //   },
                        // })}
                        {...register(`items.${index}.weight`, {
                          onChange: (e) => {
                            const weight = formatNumberWithComma(
                              e.target.value,
                            );
                            handleQtyChange(weight, index);
                          },
                        })}
                        maxLength={19}
                        className="form-control form-control-sm p-2"
                        disabled={
                          !watch(`items.${index}.productName`) || !isEditable
                        }
                      />
                    </td>
                    {/* Moisture */}
                    <td>
                      {/* <input
                        type="text"
                        onInput={onInputFloat}
                        required
                        {...register(`items.${index}.moisture`)}
                        className="form-control form-control-sm p-2"
                      /> */}
                      <div className="input-group" key={item.id}>
                        <input
                          type="text"
                          onInput={onInputFloat}
                          // {...register(`items.${index}.moisture`, {
                          //   onChange: (e) => {
                          //     let value = e.target.value;

                          //     // Auto-clear default "0" when user starts typing
                          //     if (
                          //       value.length === 2 &&
                          //       value[0] === "0" &&
                          //       value[1] !== "."
                          //     ) {
                          //       value = value[1]; // Keep only the new digit
                          //       e.target.value = value;
                          //     }

                          //     if (parseFloat(value) > 100) {
                          //       swal({
                          //         icon: "error",
                          //         title: "Moisture should not exceed 100",
                          //         text: "Percentage discount cannot exceed 100%.",
                          //       }).then(() => {
                          //         e.target.value = "";
                          //       });

                          //       return;
                          //     }

                          //     // Remove non-numeric characters except a single decimal point
                          //     value = value.replace(/[^0-9.]/g, "");

                          //     // Ensure only one decimal point
                          //     const decimalCount = (value.match(/\./g) || [])
                          //       .length;
                          //     if (decimalCount > 1) {
                          //       value = value.slice(0, -1);
                          //     }

                          //     // Convert to float, but do not remove decimals prematurely
                          //     let numericValue = value ? parseFloat(value) : 0;

                          //     // Ensure moisture does not exceed 100
                          //     if (numericValue > 100) {
                          //       numericValue = 100;
                          //     }

                          //     // Ensure value is formatted correctly
                          //     const formattedValue = formatNumber(value); // Use `value` instead of `numericValue.toString()`

                          //     setValue(
                          //       `items.${index}.moisture`,
                          //       formattedValue,
                          //     );
                          //     calculateTotalMoisture();
                          //     calculateNetWeight(index);
                          //   },
                          // })}
                          {...register(`items.${index}.moisture`, {
                            onChange: (e) => {
                              let value = e.target.value;

                              handleMoistureChange(value, index);
                            },
                          })}
                          required
                          className="form-control form-control-sm p-2"
                          disabled={
                            !watch(`items.${index}.productName`) || !isEditable
                          }
                        />
                        <span
                          style={{
                            cursor:
                              !watch(`items.${index}.productName`) ||
                              !isEditable
                                ? "not-allowed"
                                : "pointer",
                          }}
                          className="input-group-text"
                          id="basic-addon2"
                        >
                          {watch(`items.${index}.moistureType`)}
                        </span>
                        <input
                          type="hidden"
                          {...register(`items.${index}.moistureType`)}
                        />
                        <input
                          type="hidden"
                          {...register(`items.${index}.totalPrice`)}
                        />
                        <input
                          type="hidden"
                          {...register(`items.${index}.original_php_price`)}
                        />
                      </div>
                    </td>
                    {/* Net Weight */}
                    <td>
                      <input
                        required
                        type="text"
                        // readOnly
                        onInput={onInputFloat}
                        // {...register(`items.${index}.net_weight`, {
                        //   onChange: (e) => {
                        //     let value = e.target.value;

                        //     // Auto-clear default "0" when user starts typing
                        //     if (
                        //       value.length === 2 &&
                        //       value[0] === "0" &&
                        //       value[1] !== "."
                        //     ) {
                        //       value = value[1]; // Keep only the new digit
                        //       e.target.value = value;
                        //       setValue(`items.${index}.net_weight`, value);
                        //     }

                        //     console.log(value, "value==");
                        //     calculateMoisture(index, value || 0);
                        //   },
                        // })}
                        {...register(`items.${index}.net_weight`, {
                          onChange: (e) => {
                            const netweight = formatNumberWithComma(
                              e.target.value,
                            );
                            handleNetWeightChange(netweight, index);
                          },
                        })}
                        maxLength={15}
                        className="form-control form-control-sm p-2"
                        disabled={
                          !watch(`items.${index}.productName`) || !isEditable
                        }
                      />
                    </td>
                    {/* <td>{`₱ ${watch(`items.${index}.unitPrice`)}`}</td>
                    <td>{`₱ ${watch(`items.${index}.totalPrice`)}`}</td> */}
                    <td>
                      {" "}
                      <div className="d-flex flex-column">
                        <div className="">
                          <input
                            onInput={(e) => {
                              onInputFloat(e);
                              const val = e.target.value;
                              const dotIndex = val.indexOf(".");
                              if (
                                dotIndex !== -1 &&
                                val.length - dotIndex > 5
                              ) {
                                e.target.value = val.slice(0, dotIndex + 5);
                              }
                            }}
                            // {...register(`items.${index}.unitPrice`)}
                            // {...register(`items.${index}.unitPrice`, {
                            //   onChange: (e) => {
                            //     let value = e.target.value;

                            //     if (
                            //       value.length === 2 &&
                            //       value[0] === "0" &&
                            //       value[1] !== "."
                            //     ) {
                            //       value = value[1]; // Keep only the new digit
                            //       e.target.value = value;
                            //     }

                            //     const formattedValue = formatNumber(value);

                            //     setValue(
                            //       `items.${index}.unitPrice`,
                            //       formattedValue,
                            //     );

                            //     calculateTotalMoisture();
                            //     calculateNetWeight(index);
                            //   },
                            // })}

                            {...register(`items.${index}.unitPrice`, {
                              onChange: (e) => {
                                let value = e.target.value;

                                const formattedValue =
                                  formatNumberWithComma(value);

                                handleUnitPriceChange(formattedValue, index);
                              },
                            })}
                            maxLength={19}
                            className="form-control form-control-sm p-2"
                            disabled={
                              !watch(`items.${index}.productName`) ||
                              !isEditable
                            }
                            // readOnly
                            // onChange={(e) => {
                            //   const unitPrice =
                            //     formatNumberWithCommas(e.target.value) || "";
                            //   setValue(`items.${index}.unitPrice`, unitPrice);
                            // }}
                          />
                        </div>
                        {/*Old Supplier Price */}
                        {/* {watch(`items.${index}.productId`) && (
                          <div className="">
                            {watch(`items.${index}.supplier_price`) >
                            watch(`items.${index}.unitPrice`) ? (
                              <span className="text-primary">
                                Below Supplier Price (
                                {parseFloat(
                                  watch(`items.${index}.supplier_price`) || 0,
                                ).toLocaleString(
                                  "en-US",
                                  dynamicCurrencyOptions(findCurrencyName),
                                )}
                                )
                              </span>
                            ) : watch(`items.${index}.supplier_price`) ===
                              watch(`items.${index}.unitPrice`) ? (
                              <span className="text-success">
                                Same Price (
                                {parseFloat(
                                  watch(`items.${index}.supplier_price`) || 0,
                                ).toLocaleString(
                                  "en-US",
                                  dynamicCurrencyOptions(findCurrencyName),
                                )}
                                )
                              </span>
                            ) : (
                              <span className="text-danger">
                                Above Supplier Price (
                                {(
                                  parseFloat(
                                    watch(`items.${index}.supplier_price`),
                                  ) || 0
                                ).toLocaleString(
                                  "en-US",
                                  dynamicCurrencyOptions(findCurrencyName),
                                )}
                                )
                              </span>
                            )}
                          </div>
                        )} */}

                        {watch(`items.${index}.productId`) && (
                          <div className="">
                            {parseNumber(
                              watch(`items.${index}.supplier_price`),
                            ) >
                            parseNumber(watch(`items.${index}.unitPrice`)) ? (
                              <span className="text-primary">
                                Below Supplier Price (
                                {formatCurrency(
                                  parseNumber(
                                    watch(`items.${index}.supplier_price`),
                                  ),
                                  currentCurrency,
                                )}
                                )
                              </span>
                            ) : parseNumber(
                                watch(`items.${index}.supplier_price`),
                              ) ===
                              parseNumber(watch(`items.${index}.unitPrice`)) ? (
                              <span className="text-success">
                                Same Price (
                                {formatCurrency(
                                  parseNumber(
                                    watch(`items.${index}.supplier_price`),
                                  ),
                                  currentCurrency,
                                )}
                                )
                              </span>
                            ) : (
                              <span className="text-danger">
                                Above Supplier Price (
                                {formatCurrency(
                                  parseNumber(
                                    watch(`items.${index}.supplier_price`),
                                  ),
                                  currentCurrency,
                                )}
                                )
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                    </td>
                    {/* Discount (per product) */}
                    <td>
                      <InputGroup size="sm" style={{ minWidth: "140px" }}>
                        <button
                          type="button"
                          className="btn btn-primary"
                          title={
                            itemsValues[index]?.discountType === "fixed"
                              ? "Discount type: Fixed Amount. Click to switch to Percentage (%)"
                              : "Discount type: Percentage (%). Click to switch to Fixed Amount"
                          }
                          style={{ userSelect: "none", minWidth: "2.5rem" }}
                          onClick={() => handleItemDiscountToggle(index)}
                          disabled={
                            !watch(`items.${index}.productName`) || !isEditable
                          }
                        >
                          {itemsValues[index]?.discountType === "fixed"
                            ? currencySymbol[currentCurrency]
                            : "%"}
                        </button>
                        <input
                          type="hidden"
                          {...register(`items.${index}.discountType`)}
                        />
                        <Controller
                          name={`items.${index}.discount`}
                          control={control}
                          render={({ field }) => (
                            <NumberInDecimals
                              value={field.value ?? ""}
                              onChange={(value) =>
                                handleItemDiscountChange(value, index)
                              }
                              decimals={2}
                              placeholder="0"
                              className="form-control form-control-sm p-2 text-danger text-end"
                              disabled={
                                !watch(`items.${index}.productName`) ||
                                !isEditable
                              }
                            />
                          )}
                        />
                      </InputGroup>
                    </td>
                    <td>
                      {" "}
                      {/* Subtotal after the per-product discount; the raw
                          line amount stays in the hidden totalPrice field */}
                      <input
                        value={truncateToTwoDecimals(
                          getItemBaseAmount(itemsValues[index]) -
                            getItemDiscountAmount(itemsValues[index]),
                        )}
                        className="form-control form-control-sm p-2"
                        readOnly
                      />
                    </td>
                    <td className="text-center">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => {
                          if (fields.length > 1) {
                            remove(index);
                          } else {
                            swal({
                              title: "Oops!",
                              text: "Cannot delete the last item",
                              icon: "warning",
                              buttons: false,
                              timer: 2000,
                              dangerMode: true,
                            });
                          }
                        }}
                        disabled={fields.length === 1 || !isEditable}
                      >
                        <i className="fa-solid fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button
            type="button"
            className="btn btn-primary rounded-circle scroll-fab"
            onClick={scrollPageToTop}
            title="Scroll to Top"
            aria-label="Scroll to Top"
            style={{
              position: "fixed",
              right: "24px",
              bottom: "82px",
              zIndex: 1030,
            }}
          >
            <i className="fa-solid fa-arrow-up fs-5"></i>
          </button>
          <div className="text-end mt-2">
            <button
              className="btn btn-primary btn-sm rounded-pill px-3 d-inline-flex align-items-center gap-2"
              type="button"
              onClick={isEditable ? addNewItem : null}
            >
              <i className="fa-solid fa-plus"></i>
              New Item
            </button>
          </div>
        </div>
        <div className="row mx-auto p-2 mt-4 mb-4">
          <div className="col-sm"></div>
          <div className="col-sm border-end">
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Total Qty : </span>
              <span className="text-secondary">
                {formatToTwoDecimal(calculateTotalWeightInKilo)} (Kg)
              </span>
            </div>
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Total Moisture :</span>
              <span className="text-danger">
                {formatToTwoDecimal(
                  calculateTotalWeightInKilo - calculateTotalNetWeightInKilo,
                )}{" "}
                (Kg)
              </span>
            </div>
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Total Net Qty :</span>
              <span className="text-danger">
                {formatToTwoDecimal(calculateTotalNetWeightInKilo)} (Kg)
              </span>
            </div>
          </div>
          <div className="col-sm">
            {/* ── Product rows ──────────────────────────────────────── */}
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Total Qty Amount</span>
              <span className="text-secondary">
                {/* {formatCurrency(rawTotalWeight, currentCurrency)} */}
                {formatCurrency(calculateTotalWeightAmount, currentCurrency)}
              </span>
            </div>

            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Total Amount of Moisture</span>
              <span className="text-danger">
                {formatCurrency(
                  calculateTotalWeightAmount - calculateTotalNetWeightAmount,
                  currentCurrency,
                )}
              </span>
            </div>

            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Total Net Qty Amount</span>
              <span className="text-danger">
                {/* {formatCurrency(
                  rawTotalWeight - totalMoisture,
                  currentCurrency,
                )} */}
                {formatCurrency(calculateTotalNetWeightAmount, currentCurrency)}
              </span>
            </div>

            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Total Product Discount</span>
              <span className="text-danger">
                {formatCurrency(calculateTotalItemDiscount, currentCurrency)}
              </span>
            </div>

            <hr className="flex-grow-1 mx-3" />

            {/* ── Subtotal ──────────────────────────────────────────── */}
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Subtotal</span>
              <span className="text-secondary">
                {/* {formatCurrency(productSubtotal, currentCurrency)} */}
                {formatCurrency(TotalAmountBreakdownSubtotal, currentCurrency)}
              </span>
            </div>

            {/* ── Discount ──────────────────────────────────────────── */}
            <div className="w-100 d-flex flex-row justify-content-between p-2 align-items-center">
              <span className="me-2 text-nowrap">Discount</span>
              <InputGroup size="sm" style={{ maxWidth: "200px" }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  title={
                    isPercent
                      ? "Discount type: Percentage (%). Click to switch to Fixed Amount"
                      : "Discount type: Fixed Amount. Click to switch to Percentage (%)"
                  }
                  style={{ userSelect: "none", minWidth: "2.5rem" }}
                  onClick={isEditable ? handleDiscountToggle : null}
                >
                  {isPercent ? "%" : currencySymbol[currentCurrency]}
                </button>
                {/* <InputGroup.Text>
                  {findCurrencyName?.currency_name ?? "PHP"}
                </InputGroup.Text> */}
                <NumberInDecimals
                  value={primary_discount}
                  onChange={handleDiscountChange}
                  decimals={2}
                  placeholder="0"
                  className="form-control form-control-sm py-2 text-danger text-end fs-6"
                  readOnly={!isEditable}
                />
              </InputGroup>
            </div>

            {/* ── Gross Amount ──────────────────────────────────────── */}
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Gross Amount</span>
              <span className="text-secondary">
                {formatCurrency(totalGrossAmountBreakdown, currentCurrency)}
              </span>
            </div>

            <hr className="flex-grow-1 mx-3" />

            {/* ── VAT (green) ───────────────────────────────────────── */}
            {vendorSelected && (
              <div className="w-100 d-flex flex-row justify-content-between p-2">
                <span style={{ color: "#198754" }}>
                  {Number(vat) > 0 && !isSpecialTax
                    ? `VAT (${parseFloat(vat)}%)`
                    : "Non-VAT"}
                </span>
                <span style={{ color: "#198754" }}>
                  {Number(vat) > 0 && !isSpecialTax
                    ? formatCurrency(vatAmountBreakdown, currentCurrency)
                    : "0.00"}
                </span>
              </div>
            )}

            {/* ── Withholding Tax ───────────────────────────────────── */}
            {vendorSelected && taxId && Number(taxRate) > 0 && (
              <div className="w-100 d-flex flex-row justify-content-between p-2">
                <span>Withholding Tax ({parseFloat(taxRate)}%)</span>
                <span className="text-danger">
                  {formatCurrency(WHTaxBreakdownAmount, currentCurrency)}
                </span>
              </div>
            )}

            {vendorSelected && (
              <div className="w-100 d-flex flex-row justify-content-between p-2 align-items-center">
                <Form.Check
                  type="checkbox"
                  id="special-tax-computation"
                  disabled={!isEditable}
                  label={
                    <span
                      title={`E = Gross Amount * 1.12\nL = Gross Amount * 0.12\nI = E * 0.01\nTax (Special Computation) = L - I`}
                      style={{ cursor: "pointer", userSelect: "none" }}
                    >
                      Tax{" "}
                      <small className="text-muted">
                        (Special Computation)
                      </small>
                    </span>
                  }
                  className="mb-0 d-flex align-items-center gap-2"
                  style={{ cursor: "pointer" }}
                  checked={isSpecialTax}
                  onChange={handleSpecialTax}
                />
                {isSpecialTax && (
                  <span className="text-success">
                    {formatCurrency(specialTaxAmountBreakdown, currentCurrency)}
                  </span>
                )}
              </div>
            )}

            {vendorSelected && <hr className="flex-grow-1 mx-3" />}

            {/* ── Weighing Fee (Non-Taxable) ────────────────────────── */}
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>
                Weighing Fee <small className="text-muted">(Non-Taxable)</small>
              </span>
              <span className="text-danger">
                <Controller
                  name="weighingFee"
                  control={control}
                  render={({ field }) => (
                    <NumberInDecimals
                      decimals={2}
                      placeholder="0.00"
                      className="form-control form-control-sm py-2 text-danger text-end fs-6 input-payable-form"
                      style={{ paddingRight: validated ? "2rem" : "0.5rem" }}
                      value={field.value}
                      onChange={field.onChange}
                      readOnly={!isEditable}
                    />
                  )}
                />
              </span>
            </div>

            {/* ── Other Fees (Non-Taxable) ──────────────────────────── */}
            {(() => {
              const start = otherFeePage * OTHER_FEE_PAGE_SIZE;
              const pageSlice = otherFees.slice(
                start,
                start + OTHER_FEE_PAGE_SIZE,
              );
              const totalPages = Math.ceil(
                otherFees.length / OTHER_FEE_PAGE_SIZE,
              );
              return (
                <>
                  {pageSlice.map((fee, pageIndex) => {
                    const index = start + pageIndex;
                    return (
                      <div
                        key={index}
                        className="w-100 d-flex flex-row justify-content-between p-2"
                      >
                        <Form.Control
                          type="text"
                          size="sm"
                          placeholder="Fee Name"
                          value={fee.feeName}
                          onChange={(e) =>
                            handleFeeChange(index, "feeName", e.target.value)
                          }
                          readOnly={!isEditable}
                        />
                        <NumberInDecimals
                          className="form-control form-control-sm text-danger"
                          placeholder="0.00"
                          decimals={2}
                          value={fee.feeAmount}
                          onChange={(e) => {
                            handleFeeChange(index, "feeAmount", e);
                          }}
                          readOnly={!isEditable}
                        />
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => (isEditable ? removeFee(index) : null)}
                        >
                          X
                        </button>
                      </div>
                    );
                  })}
                  {totalPages > 1 && (
                    <div className="w-100 d-flex justify-content-between align-items-center px-2 pb-1">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        disabled={otherFeePage === 0}
                        onClick={() => setOtherFeePage((p) => p - 1)}
                      >
                        ‹ Prev
                      </button>
                      <small className="text-muted">
                        {otherFeePage + 1} / {totalPages}
                      </small>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        disabled={otherFeePage >= totalPages - 1}
                        onClick={() => setOtherFeePage((p) => p + 1)}
                      >
                        Next ›
                      </button>
                    </div>
                  )}
                </>
              );
            })()}

            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>
                Other Fee <small className="text-muted">(Non-Taxable)</small>
              </span>
              <button
                type="button"
                onClick={isEditable ? addNewFee : null}
                className="border-0 text-primary bg-white p-0"
              >
                Add
              </button>
            </div>

            <hr className="flex-grow-1 mx-3" />

            {/* ── Total Amount ──────────────────────────────────────── */}
            <div className="w-100 d-flex flex-row justify-content-between p-3 mt-3 total-amount-container align-items-center rounded">
              <span className="text-white">Total Amount:</span>
              <span className="text-white">
                {formatCurrency(FinalPayableAmount, currentCurrency)}
              </span>
            </div>
          </div>
        </div>

        {/* {editPOID ? (
          <div className="w-100 text-end mb-3 d-flex justify-content-end gap-2">
            {current_status === "Pending" &&
              authrztn.includes("Payable-Edit") && (
                <>
                  {!isEditable && (
                    <button
                      className="btn btn-outline-primary w-25"
                      type="button"
                      onClick={() => setIsEditable(true)}
                    >
                      Edit
                    </button>
                  )}
                </>
              )}

            {!isEditable ? (
              <button
                className="btn btn-outline-danger w-25"
                type="button"
                onClick={openPDFPreview}
                disabled={
                  stateValidation.isCutoffPosted ||
                  !stateValidation.isCutoffExists
                }
              >
                Preview PDF
              </button>
            ) : (
              <button
                className="btn btn-outline-danger w-25"
                type="button"
                onClick={() => setIsEditable(false)}
              >
                Cancel Edit
              </button>
            )}
          </div>
        ) : (
          <div className="w-100 text-end mb-3 ">
            <button
              disabled={FinalPayableAmount < 0}
              className="btn btn-primary title-button"
            >
              Save
            </button>

            {FinalPayableAmount < 0 && (
              <div className="text-danger mt-2">
                Total Amount cannot be negative.
              </div>
            )}
          </div>
        )} */}
        {editPOID ? (
          <div className="w-100 text-end mb-3 d-flex justify-content-end gap-2">
            {canEdit && !isEditable && (
              <button
                className="btn btn-outline-primary w-25"
                type="button"
                onClick={() => setIsEditable(true)}
              >
                Edit
              </button>
            )}

            {canPostApprovalEdit && !isEditable && (
              <button
                className="btn btn-outline-primary w-25"
                type="button"
                onClick={() => setIsEditable(true)}
                disabled={
                  stateValidation.isCutoffPosted ||
                  !stateValidation.isCutoffExists ||
                  stateValidation.isAdded
                }
              >
                Edit
              </button>
            )}

            {showPreviewButton ? (
              <button
                className="btn btn-outline-danger w-25 d-inline-flex align-items-center justify-content-center gap-2"
                type="button"
                onClick={openPDFPreview}
                disabled={
                  stateValidation.isCutoffPosted ||
                  !stateValidation.isCutoffExists
                }
              >
                <i className="fa-solid fa-file-pdf"></i>
                Preview PDF
              </button>
            ) : (
              <>
                <button
                  className="btn btn-outline-danger w-25"
                  type="button"
                  onClick={handleCancelEdit}
                >
                  Cancel Edit
                </button>
                <button
                  className="btn btn-outline-primary w-25"
                  type="button"
                  onClick={() => handleSaveUpdateInitial()}
                >
                  Save Changes
                </button>
              </>
            )}
          </div>
        ) : (
          <div className="w-100 text-end mb-3">
            <button
              disabled={FinalPayableAmount < 0}
              className="btn btn-primary title-button"
            >
              Save
            </button>

            {FinalPayableAmount < 0 && (
              <div className="text-danger mt-2">
                Total Amount cannot be negative.
              </div>
            )}
          </div>
        )}

        {(authrztn.includes("Payable-Edit") ||
          authrztn.includes("Payable-Approve")) &&
          stateValidation.isCutoffPosted &&
          current_status === "Pending" && (
            <div className="w-100 mt-2 text-end">
              <p className="text-danger">
                Action is prohibited as the Cutoff date has already been posted.
              </p>
            </div>
          )}

        {(authrztn.includes("Payable-Edit") ||
          authrztn.includes("Payable-Approve")) &&
          !stateValidation.isCutoffExists &&
          current_status === "Pending" && (
            <div className="w-100 mt-2 text-end">
              <p className="text-danger">
                Action is prohibited as the Cutoff date has not been created.
              </p>
            </div>
          )}

        {authrztn.includes("Payable-PostApprovalEdit") &&
          stateValidation.isCutoffPosted &&
          current_status === "Approved" && (
            <div className="w-100 mt-2 text-end">
              <p className="text-danger">
                Action is prohibited as the Cutoff date has already been posted.
              </p>
            </div>
          )}

        {authrztn.includes("Payable-PostApprovalEdit") &&
          !stateValidation.isCutoffExists &&
          current_status === "Approved" && (
            <div className="w-100 mt-2 text-end">
              <p className="text-danger">
                Action is prohibited as the Cutoff date has not been created.
              </p>
            </div>
          )}

        {authrztn.includes("Payable-PostApprovalEdit") &&
          stateValidation.isAdded &&
          current_status === "Approved" && (
            <div className="w-100 mt-2 text-end">
              <p className="text-danger">
                Action is prohibited as this payable has already been included
                in a payment.
              </p>
            </div>
          )}
      </Form>

      {/* MODALS */}
      <Modal
        show={viewPDFModal}
        size="xl"
        onHide={() => setViewPDFModal(false)}
      >
        <div className="position-relative">
          <a
            href={payablePdf.url || undefined}
            download={`Payable - ${watch("transactionId")}.pdf`}
          >
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip
                  id="tooltip-right"
                  className="me-2"
                  style={{ fontSize: "0.8rem" }}
                >
                  Download as{" "}
                  <strong className="text-danger">
                    "Payable - {watch("transactionId")}.pdf"
                  </strong>
                </Tooltip>
              }
              delay={300}
            >
              <Button
                variant="light"
                className="position-absolute btn btn-light border border-secondary-subtle mb-5 rounded-5"
                style={{ bottom: "-1.8rem", left: "1rem" }}
                disabled={!payablePdf.url}
              >
                <i class="fa-solid fa-download"></i>
              </Button>
            </OverlayTrigger>
          </a>

          {/* Approve and Reject button inside PDF Modal */}
          <div
            className="position-absolute"
            style={{
              bottom: "1.5rem",
              right: "2.5rem",
            }}
          >
            {authrztn.includes("Payable-Approve") &&
            current_status === "Pending" ? (
              <div className="d-flex gap-1">
                <button
                  className="btn btn-sm btn-danger px-3"
                  type="button"
                  onClick={(e) => handleInitialRejectConstant(e)}
                  disabled={
                    current_status !== "Pending" ||
                    stateValidation.isCutoffPosted ||
                    !stateValidation.isCutoffExists
                  }
                >
                  Reject
                </button>

                <button
                  onClick={(e) => handleInitalApproveConstant(e)}
                  disabled={
                    isApproving ||
                    current_status !== "Pending" ||
                    stateValidation.isCutoffPosted ||
                    !stateValidation.isCutoffExists
                  }
                  className="btn btn-sm btn-success d-inline-flex align-items-center gap-2"
                >
                  {isApproving ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      />
                      Approving...
                    </>
                  ) : (
                    "Approve"
                  )}
                </button>
              </div>
            ) : (
              <span
                className={`badge px-3 py-2 fs-6 ${
                  current_status === "Approved"
                    ? "bg-success-subtle text-success border border-success-subtle"
                    : "bg-danger-subtle text-danger border border-danger-subtle"
                }`}
                style={{ pointerEvents: "none" }}
              >
                {current_status}
              </span>
            )}
          </div>
          <PayablePDFFrame url={payablePdf.url} error={payablePdf.error} />
        </div>
      </Modal>
    </div>
  );
};

export default NewCreateViewPayable;
